"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translation = void 0;
var translation = {
  400: "Merci pour votre visite. Nous réparons cela tout de suite. Sera de retour bientôt. Pendant ce temps, veuillez appeler le +918042754444 pour commander votre poulet préféré.",
  401: "Merci pour votre visite. Nous réparons cela tout de suite. Sera de retour bientôt. Pendant ce temps, veuillez appeler le +918042754444 pour commander votre poulet préféré.",
  403: "Merci pour votre visite. Nous réparons cela tout de suite. Sera de retour bientôt. Pendant ce temps, veuillez appeler le +918042754444 pour commander votre poulet préféré.",
  404: "Merci pour votre visite. Nous réparons cela tout de suite. Sera de retour bientôt. Pendant ce temps, veuillez appeler le +918042754444 pour commander votre poulet préféré.",
  500: "Merci pour votre visite. Nous réparons cela tout de suite. Sera de retour bientôt. Pendant ce temps, veuillez appeler le +918042754444 pour commander votre poulet préféré.",
  501: "Merci pour votre visite. Nous réparons cela tout de suite. Sera de retour bientôt. Pendant ce temps, veuillez appeler le +918042754444 pour commander votre poulet préféré.",
  At: "à",
  No: "Non",
  OK: "D'ACCORD",
  at: "À",
  is: "est",
  na: "N / A",
  of: "de",
  on: "Au",
  xs: "XS",
  to: "pour",
  noImage: "pas d'image",
  Yes: "Oui",
  add: "Ajouter",
  and: "et",
  day: "Jour",
  eng: "Engin",
  "for": "pour",
  ga4: "GA4",
  map: "Carte",
  max: "Max",
  "new": "NOUVELLE",
  now: "maintenant",
  off: "Désactivé",
  otp: "OTP",
  phc: "les toilettes pour l'activation physique",
  sms: "Nous venons de vous envoyer un SMS",
  tab: "languette",
  upi: "upi",
  veg: "Veg",
  Okay: "D'accord",
  asap: "au plus vite",
  call: "Appel",
  cart: "Chariot",
  date: "Date",
  done: "Fait",
  edit: "Éditer",
  free: "Libérer",
  from: "depuis",
  help: "aider",
  home: "Domicile",
  list: "Liste",
  more: "Suite",
  name: "Nom",
  noon: "MIDI",
  oops: "Oops!",
  open: "Ouvre à {{time}}",
  save: "Sauver",
  text: "Texte",
  till: "jusqu'à",
  time: "Temps",
  view: "Voir",
  when: "Lorsque",
  wifi: "service wifi",
  year: "Année",
  apply: "Appliquer",
  braze: "Brouiller",
  close: "Fermer",
  ecard: "Écard",
  email: "E-mail*",
  floor: "étage",
  gotIt: "J'ai compris",
  hours: "Heures:",
  items: "ÉLÉMENTS",
  local: "en-us",
  login: "Connexion",
  month: "Mois",
  offer: "Offre",
  order: "Ordre",
  payTm: "paytm",
  promo: "promotion",
  reset: "Réinitialiser",
  retry: "Retenter",
  sorry: "Pardon,",
  terms: "Conditions",
  timer: "minuteur",
  today: "Aujourd'hui",
  total: "Le total",
  trace: "Peut contenir:",
  until: "jusqu'à ce que",
  Cancel: "Annuler",
  Submit: "Nous faire parvenir",
  Viewed: "Visualisé",
  button: "Bouton",
  callUs: "Nous appeler",
  cancel: "Annuler",
  change: "Changement",
  closed: "Fermée",
  custom: "Douane",
  "delete": "Supprimer",
  dineIn: "Dîner dans",
  donate: "Donner",
  expand: "élargir les choix de temps",
  expiry: "Exp",
  extras: "Suppléments",
  goBack: "Retourner",
  inCart: "Dans un chariot",
  kfcTxt: "KFC",
  kfcUrl: "kfc.com.au",
  kiosks: "kiosques",
  myCart: "Mon chariot",
  nonveg: "Non végétarien",
  openAt: "Ouvrir",
  orders: "ordres",
  pickup: "Ramasser",
  recipe: "Inclusions",
  redeem: "Racheter",
  refill: "recharge",
  remove: "Retirer",
  signIn: "S'identifier",
  signUp: "S'inscrire",
  sortBy: "Trier par",
  ssshhh: "Ssshhh!",
  stores: "Mes magasins",
  submit: "Créer un compte",
  unlock: "Ouvrir",
  upSize: "Augmentez votre boisson?",
  update: "METTRE À JOUR",
  viewUp: "visionner",
  viewed: "Visualisé",
  wallet: "Portefeuille",
  weHave: "Nous avons",
  zoomIn: "Agrandir",
  Locator: "Localisatrice",
  Payment: "Paiement",
  "Sign In": "S'identifier",
  account: "Compte",
  catering: 'Restauration',
  addhope: "Ajouter l'espoir",
  address: "Adresses",
  balance: "Solde",
  cartAdd: "augmenter la quantité de 1 pour",
  cartGst: "TPS",
  checked: "Vérifié",
  confirm: "Confirmer",
  contact: "Contacter",
  cvvText: "CVV *",
  "default": "Défaut",
  details: "Des détails",
  dietary: "Diététique",
  editbox: "édition",
  editing: "modification",
  evening: "SOIRÉE",
  findKfc: "Trouver un KFC",
  getHelp: "Obtenir de l'aide",
  heading: "titre",
  inStore: "En magasin",
  invalid: "Invalide",
  kJ_text: "KJ",
  kfcFood: "KFC Food",
  kfcMenu: "Menu",
  kfcNews: "KFC News and Annonces",
  kfcSign: "CONNEXION KFC",
  kfclogo: "resources/images/KFC_logo.svg",
  message: "messages",
  morning: "MATIN",
  afterNoon: "après-midi",
  nearYou: "%storeCount% kfc près de chez vous",
  oneItem: "ÉLÉMENTS)",
  openNow: "Ouvrez maintenant • jusqu'à",
  openPDP: "PDP ouvert",
  openPLP: "PLP ouvert",
  parking: "parking",
  payCash: "payer en espèce",
  payment: "Paiement",
  phonePe: "téléphone",
  present: "Cadeau:",
  privacy: "Confidentialité",
  receipt: "Reçu",
  seconds: "seconds",
  signOut: "Se déconnecter",
  support: "SOUTIEN",
  todayAt: "Aujourd'hui à",
  twitter: "Twitter",
  updated: "Personnalisé",
  validTo: "Valide pour",
  viewMap: "Voir la carte",
  viewOur: "Voir notre",
  viewing: "Visualisation",
  viewour: "Voir notre",
  weFound: "NOUS AVONS TROUVÉ",
  weSaved: "Nous avons enregistré cette commande comme une occasion",
  zoomOut: "Dézoomer",
  OrderNow: "Commandez maintenant",
  addOnMsg: "Complément (s) inclus dans votre commande",
  address2: "Adresse Ligne 2*",
  birthday: "date d'anniversaire",
  calories: "calories",
  canceled: "Annulé",
  carousal: "Vue du carrousel activé",
  cartItem: "Article",
  checkBox: "cocher",
  checkout: "VÉRIFIER",
  clearAll: "Tout effacer",
  collapse: "Effondrer les choix de temps",
  "continue": "Continuez à commander",
  delivery: "Livraison",
  dineInAt: "Dîner à",
  editName: "Modifier le nom préféré",
  emptyCvv: "Entrez le numéro CVV",
  emptyMsg: "Veuillez saisir le nom de votre commande.",
  emptyPin: "Entrez le numéro de broche",
  endingIn: "Se terminant en",
  expanded: "étendue",
  external: "externe",
  facebook: "Facebook",
  filterBy: "Filtrer par",
  freeWifi: "Wifi gratuit",
  fullName: "Nom et prénom*",
  fullname: "Nom complet * Zone d'édition",
  getTouch: "ENTRER EN CONTACT",
  giftCard: "Carte cadeau",
  hoursCap: "HEURES",
  internal: "interne",
  kfcImage: "Image KFC",
  kfcLover: "Lover KFC",
  listview: "ListView activé",
  loadMore: "Charger plus",
  location: "Emplacement",
  menuView: "Menu",
  mmddText: "Expiry Date (MM / YY)*",
  moreInfo: "Plus d'informations",
  needHelp: "Besoin d'aide?",
  newPrice: "Nouveau prix",
  nickName: "surnom",
  oldPrice: "Ancien prix",
  onlyText: "SEULEMENT Texte",
  open24Hr: "Ouvrir 24 heures",
  orderFor: "Comander pour",
  orderMsg: "Orci, Eget Tempus Risus.",
  orderNow: "Commandez maintenant",
  per_gram: "Par 100g",
  postcode: "Code postal",
  quantity: "QUANTITÉ",
  readLess: "Lire moins -",
  readMore: "En savoir plus +",
  refunded: "Remboursé",
  restroom: "salle de repos",
  savedkfc: "KFC sauvé",
  schedule: "PROGRAMME",
  selected: "choisie",
  subTotal: "Total",
  takeAway: "Ramasser",
  takeaway: "Ramasser",
  terraces: "terrasses",
  thankYou: "JE VOUS REMERCIE",
  tomorrow: "Demain",
  tryAgain: "Veuillez réessayer",
  viewCart: "Voir le chariot",
  viewMenu: "Afficher le menu",
  ERROR_ALT: "Erreur",
  EnteraCVV: "Entrez le numéro CVV",
  addCoupon: "Ajouter un coupon",
  addToCart: "Ajouter au chariot",
  allergens: "Allergènes",
  amenities: "AGRÉMENTS",
  apiButton: "Appel API",
  applelogo: "resources/images/apple_logo.svg",
  askForOTP: "Votre chauffeur vous demandera ce OTP à l'arrivée",
  breakfast: "déjeuner",
  cartItems: "Articles",
  cartTitle: "CHARIOT",
  changeCap: "Changement",
  collapsed: "s'est effondré",
  completed: "Complété",
  contactUs: "NOUS CONTACTER",
  copyRight: "droits d'auteur © KFC Canada. 2022 Tous droits réservés. Version {{appVersion}} (Prod. {{buildNumber}})",
  customise: "Personnaliser",
  customize: "Personnaliser",
  doYouWant: "Veux-tu",
  driveThru: "Drive-thru",
  driverTip: "Conseil conducteur",
  emptyName: "Entrez votre nom",
  enjoyMeal: "Profitez de votre repas de léchage des doigts!",
  enterCode: "Entrez le code",
  enterName: "Veuillez saisir le nom",
  enterYour: "Entrez votre",
  foodCourt: "Aire de restauration",
  giveAName: "donne lui un nom!",
  greetings: "Bonjour",
  hangTight: "Tenir fermement!",
  hometitle: "DOMICILE",
  instaLink: "lien Instagram",
  instagram: "Instagram",
  keepOrder: "Garder la commande",
  kfcontent: "PRÊT À VIVRE LA BELLE VIE?",
  labelName: "Nom",
  leaveText: "Partir",
  leftArrow: "Flèche gauche",
  letUsKnow: "Faites-nous mieux vous savoir",
  menuTitle: "MENU",
  moreTitle: "SUITE",
  myAccount: "Mon compte",
  noAddress: "Vous n'avez pas encore d'adresse de livraison.",
  nutrition: "La nutrition",
  offerDeal: "Offres et offres",
  onlyImage: "uniquement l'image",
  openToday: "Ouvrir aujourd'hui à",
  openUntil: "Ouvrir jusqu'à ce que",
  orderAsap: "Commandez dès que possible",
  orderFrom: "ORDRE DE",
  orderHash: "Ordre #",
  orderMode: "RÉCAPITULATIF DE LA COMMANDE",
  orderName: "Nom de commande",
  orderType: "Type de commande",
  ordersNow: "commandes maintenant.",
  per_serve: "Par service",
  pinNumber: "Code PIN*",
  saveOrder: "Enregistrer cette commande",
  savetoFav: "Enregistrer la commande préférée",
  scheduled: "Programmé",
  selectDay: "Sélectionnez une journée",
  selectKFC: "Sélectionnez un KFC",
  sorryText: "désolée,",
  storeMenu: "Menu de magasin",
  subscribe: "S'abonner",
  tipAmount: "Montant du pourboire",
  todayASAP: "Aujourd'hui, dès que possible",
  topSeller: "MEILLEUR VENDEUR",
  totalCost: "Coût total:",
  unChecked: "incontrôlée",
  unchecked: "Incontrôlée",
  unlocksIn: "Déverrouiller",
  wantToAdd: "Vous voulez ajouter ou modifier?",
  welcomeTo: "BIENVENUE À",
  yesDelete: "Oui, supprimez",
  yesKeepIt: "Oui, gardez-le",
  yourOrder: "Votre commande",
  addACoupon: "Ajouter un coupon",
  addFavName: "Ajouter le nom préféré",
  addToOrder: "Racheter",
  addressOne: "Adresses 1",
  "agree-text": "J’accepte le",
  arrowImage: "Flèche",
  backButton: "Dos",
  backToCart: "Retour au chariot",
  backToMenu: "Retour au menu",
  backtomenu: "Retour au menu",
  browseMenu: "Menu de navigation",
  cardExpiry: "Mm / yyyy *",
  cartRemove: "Éliminer",
  closedNext: "Ouvrir demain",
  contactKFC: "Contacter KFC",
  creditCard: "carte de crédit",
  deleteCard: "Supprimer la carte",
  deliveryTo: "Livraison à",
  dineInInfo: "Dîner dans les informations",
  dineInText: "sera prêt pour le dîner par",
  disclaimer: "Clause de non-responsabilité",
  "email-text": "Messagerie électronique",
  emailLabel: "E-mail",
  expiredMsg: "Dépêche-toi! Ce coupon exclusif expire bientôt!",
  favourites: "Favoris",
  giftAmount: "Montant du cadeau",
  giftpinNum: "Code PIN",
  googlelogo: "resources/images/google_logo.svg",
  handItToMe: "Me remettre",
  hereToHelp: "Nous sommes là pour aider si vous avez besoin de plus d'informations",
  hiddenText: "KFC | Commandez KFC Chicken en ligne et recherchez des restaurants",
  inprogress: "En cours",
  invalidCvv: "Numéro de VCV non valide",
  invalidMsg: "Le nom doit avoir un minimum 3 et un maximum de 20 caractères. Des caractères spéciaux non autorisés.",
  invalidPin: "Broche non valide",
  isOnTheWay: "est en route vers votre adresse",
  itemInCart: "Article dans votre panier",
  itemUnaval: "Les articles ne sont pas disponibles.",
  kfcViptext: "Devenez un VIP de KFC&trade; pour recevoir des offres exclusives et un accès de la part du colonel.",
  mainEntree: "Entrée principale",
  maxtextEnd: "Extra est sélectionné. Supprimer un supplément pour en sélectionner un autre.",
  myFavorite: "Commandes préférées",
  netbanking: "banc de file",
  noFavStore: "Vous n'avez pas encore de magasins préférés.",
  offerDeals: "Offres et offres",
  orderAgain: "Recommander",
  orderReady: "Nous nous préparons à le rendre frais!",
  otherPages: "Autres pages",
  outOfStock: "En rupture de stock",
  pastOrders: "commandes passées",
  "phone-text": "Téléphone",
  pickUpTime: "HEURE DE RAMASSAGE",
  placeOrder: "Passer la commande",
  playground: "Cour de récréation",
  preparedBy: "PREPARÉ PAR",
  processing: "EN TRAITEMENT",
  quickOrder: "Réorganisation rapide",
  reckOnText: "Vous estimez que vous voudrez commander à nouveau ceci?",
  reorderBtn: "Recommander",
  resendCode: "Renvoyer le code",
  retainCart: "Veuillez ajouter à nouveau votre nourriture au panier",
  rightArrow: "flèche droite",
  savedCards: "Cartes enregistrées",
  savedOrder: "A sauvé cette commande dans",
  searchMenu: "Rechercher notre menu",
  secretMenu: "menu secret",
  selectText: "Vous devez sélectionner",
  selectTime: "Sélectionnez une heure",
  signUpText: "S'inscrire",
  socialIcon: "Vue icônes sociales",
  startOrder: "Afficher le menu",
  takeMeHome: "Emmène moi chez toi",
  termsOfUse: "Conditions d'utilisation",
  termsofuse: "Conditions d'utilisation",
  toContinue: "continuer.",
  trackOrder: "Suivi de commande",
  unselected: "non sélectionné",
  updateCart: "Mise à jour panier",
  useAddress: "Utilise cette adresse",
  viewOffers: "Voir",
  wantToKnow: "Que voudriez-vous savoir?",
  yes_Remove: "Oui, supprimez",
  "you-an-sms": "vous un SMS",
  yourAllSet: "Tu es tous prêts",
  yourOrders: "Vos commandes",
  yourSearch: "Votre recherche",
  ClosedDueTo: "Fermé en raison de",
  DineInStore: "Walk-in dans le magasin",
  GSTincluded: "La TPS incluse",
  SERVES_TEXT: "Servages",
  SelectStore: "Commander ici",
  aSecondText: "UNE SECONDE.",
  addHopeLogo: "Ajouter le logo Hope",
  addHopeText: "Notre objectif est de nourrir 20 millions de personnes d'ici 2021.",
  addedToCart: "Ajouté à Cart!",
  addedToYour: "Ajouté à votre",
  addressHint: "La saisie du texte dans le champ de saisie déclenchera les suggestions d'adresse",
  arrvingSoon: "Arrive maintenant",
  atWithSpace: "à",
  "back-btn-id": "Dos",
  balanceText: "Solde:",
  browseStore: "Magasin de navigation",
  bucketEmpty: "Oops ! On dirait qu'il n'y a pas d'historique de commande pour vous. Permet de commencer une commande",
  buyGiftCard: "Acheter une autre carte-cadeau",
  callSupport: "Appeler l'assistance",
  cancelOrder: "Désolé, nous avons dû annuler votre commande.",
  cardDeleted: "Carte supprimée",
  cartAllHope: "Tout espoir",
  cartSubText: "Toute réduction éligible sera appliquée à l'étape suivante avant de passer votre commande.",
  cartViewAll: "Voir tout",
  changeStore: "Modifiez les paramètres de votre magasin",
  clearSearch: "Effacer la recherche",
  closeButton: "Bouton fermer",
  closingSoon: "Clôture bientôt • Jusqu'à ce que",
  collectedAt: "Collecté à",
  confirmText: "Confirmez pour lier votre compte",
  contactInfo: "INFORMATIONS DE CONTACT",
  contactless: "sans contact",
  dateOfBirth: "Date de naissance",
  delToastMsg: "Avec succès votre occasion supprime",
  deliveredAt: "Livré à",
  deliveryFee: "Frais de livraison",
  disposition: "disposition",
  downloadApp: "Télécharger l'application",
  "email-label": "Adresse e-mail*",
  emptyExpiry: "Entrez la date d'expiration",
  eneryKJText: "Énergie (KJ)",
  "error-email": "Nous n'avons pas reçu d'e-mail de votre",
  errorButton: "Appuyez sur moi pour voir un gestionnaire d'erreurs",
  findOpenKfc: "Trouver l'Open KFC",
  foundDriver: "Nous avons trouvé votre chauffeur",
  giftCardnum: "Numéro de carte-cadeau",
  goodEvening: "Bonsoir",
  gstIncluded: "Total (TPS inclus)",
  iAmHereText: "Je suis ici",
  iWillPayNow: "Je vais payer maintenant",
  information: "INFORMATIONS",
  "invalid-otp": "Veuillez entrer un OTP valide",
  invalidCard: "S'il vous plaît entrez un numéro de carte valide",
  invalidName: "Nom incorrect",
  itemUpdated: "Article mis à jour",
  keepShoping: "Continuer vos achats",
  kfcGiftCard: "Carte-cadeau KFC",
  letsgetcook: "Allons à cuisiner",
  mealOptions: "Examiner et personnaliser",
  myFavStores: "Mes magasins préférés",
  myOccasions: "Recommander",
  no_internet: "Nous sommes désolés, nous avons des problèmes avec votre connexion. Veuillez vérifier votre service wifi ou cellulaire et réessayer.",
  notSelected: "non séléctionné",
  notSignedIn: "Pas connecté",
  orderLookup: "Recherche de commande",
  otherWallet: "portefeuille",
  permanently: "EN PERMANENCE",
  phoneNumber: "Numéro de téléphone*",
  pickupOrder: "Prendre la commande",
  pickupTitle: "Prendre le support",
  productItem: "Désolé, cet aliment est",
  rdpRestroom: "Toilettes de genre neutres",
  refineItems: "Affiner les articles",
  removeTitle: "Retirer des favoris",
  reorderCaps: "RÉORGANISER",
  reviewOrder: "Ordre d'examen",
  saveAddress: "Enregistrez cette adresse de livraison à votre carnet d'adresses",
  saveChanges: "Sauvegarder les modifications",
  selectStore: "Sélectionnez votre magasin",
  setLocation: "Définir l'emplacement",
  signInToast: "Merci de vous être inscrit! Heureux de vous avoir!",
  "signin-down": "la connexion est interrompue. Réessayez ou connectez-vous avec une autre méthode.",
  sorryUnaval: "Désolé, certains articles deviennent indisponibles.",
  storeClosed: "Désolé,% storename% est actuellement fermé. Veuillez sélectionner un autre magasin ou commander pendant les heures de travail",
  trackOrders: "Commandes de piste",
  twitterLink: "lien Twitter",
  unavailable: "Indisponible",
  unsubscribe: "Se désabonner",
  upSellTitle: "Nous pensons que vous allez adorer ces",
  viewAllDeal: "Voir toutes les offres",
  viewAllMenu: "Afficher tous les menu",
  viewProduct: "Voir le produit",
  viewReceipt: "Voir le reçu",
  viewallFaqs: "Afficher toutes les FAQ",
  viewdetails: "Voir les détails",
  walkInStore: "Ramasser au magasin",
  welcomeBack: "BIENVENUE",
  whenYouHere: "Quand vous êtes ici.",
  yourAccount: "Votre compte",
  CVVisinvalid: "Le CVV n'est pas valide",
  DiscountText: "Rabais",
  GoBackToCart: "Et cliquez sur le chariot pour revenir en arrière.",
  GoToHomePage: "Aller à la page d'accueil",
  Instructions: "Livraison INSTRUCTIONS",
  KfcToYourCar: "KFC à votre voiture",
  "account-ins1": "Menu étendu pour faire ce que vous aimez",
  "account-ins2": "Recevez des offres spéciales",
  "account-ins3": "Réorganisez vos favoris",
  accountTitle: "COMPTE",
  addDriverTip: "Ajouter un conseil de conducteur",
  addressSaved: "Adresse enregistrée",
  addressValue: "adresse",
  businessDays: "Jours ouvrables",
  callKFCstore: "Appelez KFC Store",
  cartCheckout: "Vérifier",
  cartIncluTax: "Frais de livraison",
  cartInfoText: "Le prix du menu varie entre les types de commandes.",
  cartSubTotal: "Sous-total",
  cartfaqtitle: "FAQ",
  cateringMenu: "Menu de restauration",
  cateringText: "Restauration",
  changePickup: "Changer pour ramasser",
  changedPrice: "Les articles ont changé le prix.",
  checkBalance: "Vérifier le solde",
  chooseAStore: "Choisissez un magasin",
  closePopOver: "Appuyez sur moi pour fermer Popover1",
  closedStatus: "FERMÉE",
  couponCopied: "Succès! Votre coupon a été copié!",
  currentOrder: "Commande actuelle",
  cutomizeYour: "Personnalisez votre",
  deliverToYou: "% StoreCount% kfc qui vous livre",
  deliveryInfo: "Informations sur la livraison",
  deliveryTime: "DÉLAI DE LIVRAISON",
  discountCode: "Code de réduction",
  dropdownText: "Langue",
  editItemText: "Modifier l'article",
  editQuantity: "Modifier la quantité",
  editorPickup: "Pick & Client de l'éditeur",
  "email-in-use": "L'adresse e-mail peut être utilisée",
  emailAddress: "Adresse e-mail*",
  emptyAddress: "Entrez votre adresse",
  enterMessage: "Entrez le message ici.",
  entrYourMail: "Entrer votre Email",
  "error-signup": "compte social. Veuillez réessayer de vous inscrire.",
  facebookLink: "Lien Facebook",
  facebooklogo: "resources/images/facebook_logo.svg",
  failureretry: "Retenter",
  fingerLickin: "Finger Lickin ’Got It! Ajouté à votre panier!",
  footer_links: "liaisons de page",
  getDirection: "Obtenir des directions",
  giftErrTitle: "OH NON!",
  greetingGood: "BONNE",
  hasNowClosed: "A maintenant fermé",
  hasScheduled: "a programmé",
  haveQuestion: "Vous avez encore une question?",
  helpDropdown: "Comment pouvons-nous vous aider aujourd'hui?*",
  inExtrasText: "dans les extras",
  instructions: "INSTRUCTIONS",
  invaidInputs: "Votre commande n'a pas pu être trouvée",
  keepBrowsing: "Continuez à naviguer",
  keepShopping: "Continuer vos achats",
  kfcWebAndApp: "ORDRE \n  LIVRAISON",
  linkaccounts: "Associer des comptes",
  makeItACombo: "Faites-en un combo",
  mobileNumber: "Numéro de portable",
  nameExistMsg: "Il y a déjà un autre favori avec ce nom. Entrez un autre nom de commande",
  nextLocation: "Emplacement suivant",
  noNearestKFC: "Pas de magasin KFC le plus proche",
  noOrderFor12: "Aucune commande n'a été passée au cours des 12 derniers mois.",
  noSavedCards: "Vous n'avez aucune carte enregistrée.",
  nokfcnearyou: "Désolé, il n'y a pas de KFC près de chez vous",
  notavailable: "Pas disponible",
  offerApplied: "Offre appliquée",
  offersForYou: "Offres pour vous",
  openTomorrow: "Ouvert demain à {{time}}",
  orderDetails: "détails de la commande",
  orderHistory: "Historique des commandes",
  orderItAgain: "Commandez-le à nouveau",
  orderReceipt: "Récépissé de commande",
  orderSummary: "RÉCAPITULATIF DE LA COMMANDE",
  orderhistory: "Historique des commandes",
  outOfService: "Hors service",
  payCashTitle: "Paiement à la livraison",
  pdpAddToCart: "Ajouter à la commande",
  personalInfo: "Informations personnelles",
  pleaseSelect: "Veuillez sélectionner",
  quickReorder: "Réorganisation rapide",
  reOrderAgain: "Commandez-le à nouveau",
  retryPayment: "Veuillez réessayer de payer ou sélectionner un autre mode de paiement.",
  savedAddress: "Adresse enregistrée",
  savedMessage: "Votre information a été sauvegardée",
  selectATopic: "Choisissez un sujet",
  selectOption: "Sélectionnez vos options",
  "sign-in-text": "S'IDENTIFIER",
  signInButton: "Connexion pour voir vos adresses enregistrées",
  signInSignUp: "Vous connecter vous inscrire",
  signOutText1: "Vous êtes déconnecté.",
  signOutText2: "Tu vas me manquer.",
  signinButton: "Connexion pour voir vos adresses enregistrées",
  signinSubmit: "S'identifier",
  singleResult: "Résultat pour",
  social_icons: "sociaux sociaux",
  takeawayFrom: "Ramasser",
  takeawayInfo: "Ramasser les informations",
  thatNotRight: "Ce n'est pas juste",
  tokenExpired: "Votre session a expiré. Veuillez vous reloger ou continuer en tant qu'invité.",
  tradingHours: "Heures de négociation",
  wantToModify: "Vous voulez ajouter ou modifier?",
  "we-just-sent": "nous venons d'envoyer",
  weAreWorking: "Nous travaillons sur",
  "you-an-email": "VOUS UN EMAIL",
  yourCatering: "Votre commande de restauration sera prête à ramasser en magasin",
  yourDelivery: "Votre livraison par",
  yourLocation: "Votre emplacement",
  FeedbackEmail: "kfcfeedback@yum.com",
  Order_Summary: "Résumé de la commande KFC",
  ScheduleOrder: "Ordre de planification",
  addHopeHeader: "Faites un don de 5,00 ₹ pour ajouter de l'espoir.",
  addNewAddress: "Ajouter de nouvelles adresses",
  addNewProduct: "Ajouter un nouveau produit",
  addToOccasion: "Ajouter aux Favoris",
  address2Error: "S'il-vous-plaît entrez une adresse valide.",
  addressHeader: "En-tête d'adressage",
  alreadyMember: "Déjà membre?",
  aptSuiteFloor: "APT / Suite / plancher",
  bottleDeposit: "Dépôt de bouteilles",
  breakfastMenu: "Menu petit-déjeuner disponible jusqu'à 11h",
  browseTheMenu: "Parcourir le menu",
  bundleOptions: "Options de regroupement",
  buttonPopOver: "Appuyez sur moi pour montrer le deuxième popover",
  cartDownArrow: "flèche vers le bas",
  cartMinusGrey: "diminuer la quantité",
  cartRemoveAll: "Enlever tout",
  cartRighttick: "Tic droit",
  cateringOrder: "Commande de restauration",
  checkoutAlert: "Ceci est une alerte d'erreur - vérifiez-le!",
  clearOccasion: "Nom de commande claire",
  contentButton: "Appuyez sur moi pour voir un bouton de contenu",
  continueToPay: "Continuez à payer",
  couponSuccess: "Succès! Votre coupon a été appliqué!",
  currentOrders: "Commandes actuelles",
  defaultString: "pour commander votre poulet préféré.",
  deleteAccount: "Supprimer le compte",
  deliveryHours: "Heures de livraison",
  deliveryOrder: "Bon de livraison",
  deliveryTitle: "Aide à la livraison",
  dineInOptions: "Dîner dans les options",
  editFavourite: "Modifier le nom préféré",
  editOrderName: "Modifier le nom de l'ordre",
  editOrderType: "Modifier le type de commande",
  effectiveDate: "Date effective:",
  emailHelpText: "S'il vous plaît, mettez une adresse email valide.",
  emptyCardName: "Entrez le nom complet",
  emptyFavStore: "Vous n'avez pas encore de magasins préférés.",
  errorDeleting: "Erreur de suppression du compte",
  exclusiveDeal: "Accord exclusif",
  extraToppings: "garnitures supplémentaires",
  findingDriver: "Trouver un chauffeur avant de commencer à cuisiner ...",
  firstLastName: "firstname.lastname@email.prénom.nom@email.com",
  generic_error: "Merci pour votre visite. Nous réparons cela tout de suite. Sera de retour bientôt. Pendant ce temps, veuillez appeler le +918042754444 pour commander votre poulet préféré.",
  getDirections: "Obtenir des directions",
  giftCardTitle: "CARTE CADEAU",
  haveAQuestion: "Avoir une question?",
  invalidExpiry: "Date d'expiration non valide",
  invalidQRCode: "Code QR invalide Souhaitez-vous explorer le magasin KFC à proximité.",
  isAlmostThere: "est presque là",
  isClosedDueTo: "est actuellement fermé en raison de",
  isClosingSoon: "se ferme bientôt.",
  kfcRestaraunt: "Restaurant KFC",
  largeCarryBag: "Grand sac de transport",
  lastNameLabel: "Nom de famille",
  leaveatMyDoor: "Laisser à ma porte",
  leftArrowCaps: "Flèche gauche",
  "link-accounts": "ASSOCIER DES COMPTES",
  mandatorynote: "Remarque: * Indique le champ requis",
  maxOrderPromo: "Vous avez atteint le montant maximal de la commande pour cette promo.",
  morePageTitle: "Titre Web",
  nameIsInvalid: "Le nom ne peut pas contenir de caractères spéciaux.",
  nameThisOrder: "Nom de commande",
  occasionTitle: "Nom de commande",
  oneItemUnaval: "L'article n'est pas disponible.",
  onlinePayment: "Si vous avez effectué un paiement en ligne,",
  oopsWentWrong: "Oups quelque chose s'est mal passé!",
  orderAccepted: "Ordre accepté",
  orderAgainBtn: "Commander à nouveau",
  orderDateTime: "Date et heure de commande",
  orderForLater: "Commande pour plus tard",
  orderOnTheWay: "Commandez sur le chemin",
  orderPastTime: "Nous sommes désolés, mais l'heure prévue de votre commande actuelle est passée. Veuillez reprogrammer votre temps de commande pour continuer.",
  orderReceived: "ORDRE REÇU",
  "otp-sms-title": "NOUS VENONS DE VOUS ENVOYER UN SMS",
  paymentHeader: "PAIEMENT",
  pdpUpsizeDesc: "Grands frites et boissons",
  phoneHelpText: "Veuillez saisir le numéro de mobile valide.",
  pickUpMethods: "Suivi de commande",
  pickUpSupport: "Prendre le support",
  pickupMethods: "Méthodes de ramassage",
  postcodeError: "Entrez la banlieue ou le code postal",
  privacyPolicy: "politique de confidentialité",
  promosRewards: "Promos et récompenses",
  questionForUs: "Question pour nous?",
  rdpNoDelivery: "Pardon! La livraison n'est pas actuellement disponible dans ce restaurant.",
  refundMessage: "Votre transaction de commande a échoué et votre remboursement est le traitement. Veuillez nous contacter si vous avez des questions.",
  removeFavMenu: "Supprimer du menu préféré",
  roundTheClock: "24X7",
  "save-btn-text": "Sauvegarder",
  saveThisOrder: "Enregistrer cette commande",
  scheduleOrder: "Ordre de planification",
  scheduledCaps: "PROGRAMMÉ",
  scheduledTime: "Heure prévue",
  selectedSlide: "diapositive sélectionnée",
  signInAccount: "CONNECTEZ-VOUS À VOTRE COMPTE",
  spinnerButton: "Appuyez sur moi pour voir un spinner",
  startNewOrder: "Démarrer la nouvelle commande",
  thatsAllFolks: "C'est tout, les amis",
  thatsAllRight: "Ce n'est pas juste",
  tickToAddHope: "Cochez pour ajouter de l'espoir.",
  tipYourDriver: "Donnez un pourboire à votre chauffeur",
  trackDelivery: "Livraison de piste",
  useMyLocation: "Utilise ma location",
  viewAllPromos: "Voir toutes les promos et récompenses",
  welcomeBackTo: "BON RETOUR À",
  yourCartEmpty: "VOTRE PANIER EST VIDE. Commençons une commande!",
  yourPastOrder: "Vos commandes",
  yourScheduled: "Your scheduled",
  Congratulation: "TOUTES NOS FÉLICITATIONS!",
  Page_Title_FAQ: "FAQ KFC",
  Page_Title_Faq: "FAQ KFC",
  accoundSetting: "Paramètres du compte",
  accountFavPage: "Compte - favoris",
  addToFavourite: "Ajouter au favori",
  addToYourOrder: "pièces au total pour l'ajouter à votre commande.",
  addressUpdated: "Adresse mise à jour",
  backToCheckOut: "Retour Commander",
  bankTextHeader: "Banque",
  browsecategory: "Parcourir les catégories",
  buttonTemplate: "Bouton de modèle",
  callRestaurant: "Appeler le restaurant",
  cardNumberText: "Numéro de carte*",
  cartMinusBlack: "diminuer la quantité de 1 pour",
  changeDelivery: "Passer à la livraison",
  changeLanguage: "Changer de langue",
  checkBackAgain: "Revenez bientôt pour de nouvelles promotions et récompenses juste pour vous",
  checkoutFaster: "Découvrez plus vite",
  closeGiftClose: "Fermez la boîte de dialogue Balance de votre carte-cadeau",
  comboSubHeader: "Souhaitez-vous en faire un combo? Sélectionnez l'une des options ci-dessous.",
  confirmChanges: "Confirmer les modifications",
  dayMonthSubmit: "Le jour et le mois sont requis pour soumettre",
  delBtnOccasion: "Supprimer cette occasion",
  deliveryDriver: "LIVREUR",
  deliverycharge: "Frais de livraison",
  deriverArrived: "Deriver est arrivé",
  dippingSauceId: "C-30055-Prod",
  discardChanges: "Annuler les modifications",
  driveThruQuote: "Conduisez et citez votre numéro de commande, prenez la fenêtre de la collection et profitez de votre repas",
  driverArriving: "Conducteur arrivant",
  editSelections: "Modifier les sélections",
  emailMarketing: "Publicité par e-mail",
  emptyCouponMsg: "Entrez votre code de coupon.",
  emptyOccasions: "Vous n'avez pas encore créé d'occasions",
  emptyOccassion: "Le nom d'occasion ne doit pas être vide",
  enterOrderName: "Veuillez saisir le nom de votre commande.",
  firstNameLabel: "Prénom",
  forMembersOnly: "Connectez-vous à l'achat",
  giftcardNumber: "Numéro de carte-cadeau *",
  giftcardTender: "carte cadeau",
  giveUsYourName: "Donnez-nous votre nom ou votre numéro de commande lorsque vous êtes ici.",
  gladStaticText: "Heureux d'avoir pu aider",
  googleApiError: "Désolé, les services de localisation Google sont en baisse. Veuillez vérifier votre connexion Internet et réessayer.",
  hasBeenDelayed: "a été retardé",
  insideYourMeal: "Dans votre repas",
  invalidEmailId: "ID de messagerie invalide",
  invalidOrderId: "Pas un numéro de commande valide",
  kfcLocalOffers: "Sélectionnez un KFC pour voir les offres locales",
  legalInfoText1: "L'apport quotidien moyen adulte est de 8700kj.",
  legalInfoText2: "^ Pepsi Max, Pepsi, Pepsi Freeze & Mountain Dew Freeze contient de la caféine. Le gel de la rosée des montagnes n'est pas recommandé pour les enfants, les femmes enceintes ou allaitantes ou les individus sensibles à la caféine.",
  "mandatory-text": "* Ces champs sont nécessaires pour continuer.",
  maxBucketToast: "Une valeur de seau maximale de 100 $ à la caisse.",
  maxtextInitial: "Tu as déjà",
  nameExistError: "Il y a déjà une adresse enregistrée avec ce nom.",
  nameOnCardText: "Nom sur la carte*",
  nationalOffers: "Offres nationales",
  noneditionable: "n'est pas modifiable",
  noteItemsAdded: "Veuillez noter que vos articles seront ajoutés à votre panier.",
  occassionLabel: "Nom d'occasion",
  orderDelivered: "Commande livrée",
  orderFailedMsg: "Entrée la messagerie nécessaire ici. UT dans Viverra Tellus Enean Pharetra Enim",
  "otp-code-label": "Le code de vérification*",
  "otp-form-title": "Veuillez saisir le code de vérification que nous venons d'envoyer à :",
  outForDelivery: "En cours de livraison",
  "password-label": "Mot de passe*",
  paymentOptions: "options de paiement",
  pdpChooseStore: "Choisissez un mode de magasin et de commande pour afficher les prix et la disponibilité dans votre région.",
  pdpUpsizeTitle: "Repas de taille",
  plsReviewOrder: "Veuillez consulter votre commande",
  popOverButton1: "Appuyez sur moi pour voir First Popover",
  processingYour: "Traitement de votre",
  promoAddToCart: "Ajouter à la commande",
  readyForDineIn: "Prêt pour le dîner",
  readyForPickup: "Prêt pour le ramassage!",
  readyToCollect: "Prêt à collecter",
  recaptchaLabel: "Recaptcha",
  removedFromFav: "Retiré des favoris",
  rightArrowCaps: "Flèche droite",
  saveAddressBtn: "Enregistrer l'adresse de livraison",
  savedAddresses: "Adresses enregistrées",
  searchThisArea: "Recherchez cette zone",
  secretMenuView: "Menu secret",
  secureCheckout: "Paiement sécurisé",
  selectCarryBag: "Sélectionnez un grand sac de transport",
  selectQuantity: "SÉLECTIONNEZ LA QUANTITÉ",
  sortVisitError: "Nous avons rencontré un problème. Veuillez réessayer.",
  specialCharErr: "Le nom ne peut pas contenir de caractères spéciaux",
  startYourOrder: "Commencez votre commande",
  storeCloseText: "Magasin fermé",
  subscribeEmail: "Je veux connaître les trucs sympas chez KFC sur Email & SMS (je sais que je peux désabonner à tout moment).",
  suggestionText: "La saisie du texte dans le champ de saisie déclenchera les suggestions de recherche",
  switchToDineIn: "Passer à Dine-in",
  technicalError: "Ouvert maintenant (commande en ligne indisponible)",
  thatsAllForNow: "C'EST TOUT POUR LE MOMENT",
  trackYourOrder: "Suivre votre commande",
  "try-again-text": "Essayer à nouveau",
  turnedNoResult: "retourné aucun résultat",
  updatedAddress: "Adresse mise à jour",
  "use-your-email": "UTILISEZ VOTRE COURRIEL",
  whatSecretMenu: "Quel menu secret ?!",
  BrowseStoreMenu: "Menu de magasin de navigation",
  MODALHEADERTEXT: "Personnalisez votre",
  MultipleResults: "résultats pour",
  Page_Title_Cart: "Chariot KFC",
  Page_Title_Help: "Aide KFC",
  YourKFCLocation: "Votre restaurant KFC",
  addToFavourites: "ajouter aux Favoris",
  addressErrorMsg: "Le surnom d'adresse ne peut pas être le même qu'une adresse précédemment enregistrée.",
  browseMenuTitle: "Parcourez le menu du restaurant sélectionné.",
  cancelSelection: "Annuler les sélections",
  cartAddMoreFood: "Ajouter plus de nourriture",
  cartAddMoreMenu: "Ajouter plus de menu",
  cartGstIncluded: "La TPS incluse",
  cartOffersDeals: "Appliquer des promotions et des récompenses",
  cartSummaryNote: "Remarque: Toutes les promotions, récompenses et remises éligibles seront appliquées à l'étape suivante avant de passer votre commande.",
  categoriesImage: "Image des catégories de navigation",
  cateringWarning: "Les ordres de restauration nécessitent une ramassage du restauarant.",
  changedYourMind: "as changé d'avis?",
  checkedInClosed: "enregistré-fermé",
  checkedInRemake: "checkin-remake",
  checkedInStatus: "enregistrée",
  comboSubHeader1: "Souhaitez-vous en faire un combo?",
  comboSubHeader2: "Sélectionnez l'une des options ci-dessous.",
  completedOrders: "commandes terminées",
  continueAsGuest: "Continuer en tant qu'invité",
  continueExplore: "Continuez à explorer notre option de menu",
  continuePayment: "Continuez à payer",
  currentlyClosed: "est actuellement fermé. Veuillez sélectionner un autre magasin ou commander pendant les heures de travail.",
  delAddressTitle: "Êtes-vous sûr de vouloir supprimer cette occasion?",
  deliveredAround: "sera livré autour",
  deliveryAddress: "Adresse de livraison",
  deliveryOptions: "OPTIONS DE LIVRAISON",
  deliverySupport: "Aide à la livraison",
  doNotSellMyInfo: "Ne vendez pas mes informations personnelles",
  editbtnOccasion: "Modifier le nom préféré",
  emailStaticText: "Quelle est votre adresse e-mail",
  emptyCardNumber: "Entrez le numéro de carte",
  emptyCartBanner: "Bannière de chariot vide",
  emptyPostalCode: "Entrez le code postal de facturation",
  emptySavedStore: "Vous n'avez pas encore d'adresse de livraison.",
  enquiryDropdown: "De quoi parle cette demande d'application KFC? *",
  exclusiveOffers: "Connectez-vous pour voir des offres et des offres exclusives",
  exploreCatering: "Explorer la restauration",
  exploreFoodItem: "Explorez nos divers autres aliments",
  favNameExistMsg: "Il y a déjà un autre favori avec ce nom.",
  favouriteOrders: "Commandes préférées",
  feedbackSuccess: "Succès",
  findNearByStore: "Trouvez le magasin à proximité",
  giftCartMessage: "Message",
  giftPurchaseErr: "Il semble qu'il y ait un problème avec l'achat de la carte-cadeau",
  infoCorrectText: "Informations correctes en juin 2022",
  invalidPhoneNum: "Numéro de téléphone invalide",
  itemUnavailable: "Indisponible",
  labelPostalCode: "code postal",
  loadMoreFavMenu: "Chargez le menu préféré",
  mandatoryFields: "* Tous les champs sont requis",
  myOccassionText: "Mes occasions",
  nameOrderNumber: "Donnez-nous votre nom ou votre numéro de commande",
  newOffersForYou: "De nouvelles offres pour vous!",
  onePromoApplied: "Une promotion appliquée, en supprimez pour en ajouter un autre",
  orderUpdateText: "nous avons mis à jour le statut de votre commande",
  otherWalletText: "Autre portefeuille",
  "otp-email-title": "NOUS VENONS DE VOUS ENVOYER UN E-MAIL",
  paymentdeclined: "Malheureusement, nous ne sommes pas en mesure de traiter votre paiement dès maintenant. Le paiement a été refusé par le fournisseur de paiement.",
  phoneStaticText: "Quel est ton numéro de téléphone",
  pickupPromotion: "La promotion est pour le ramassage",
  postalCodeField: "Code Postal*",
  processingOrder: "Traitement de votre commande. Prêt en seulement une seconde.",
  redirectionText: "Redirection...",
  refundInitiated: "randonnée",
  refundinitiated: "randonnée",
  saveOrderFaster: "Économisez vos commandes et vérifiez plus rapidement",
  savedAddressMsg: "J'ai enregistré cette commande dans mon menu préféré.",
  scheduledPickup: "est prévu pour être ramassé à",
  searchAndFilter: "Rechercher",
  seePromosForYou: "Voir les promotions pour vous",
  selectOrderType: "Sélectionner le type de commande",
  sentToPosStatus: "envoyé à l'entrée",
  setYourLocation: "Définir votre position",
  signInToAccount: "CONNECTEZ-VOUS À VOTRE COMPTE",
  takeawayOptions: "Options de ramassage",
  "terms-condition": "* Veuillez m'envoyer des offres et des informations incroyables de KFC Australie et je lirai les informations importantes sur mes données ici :",
  termsConditions: "Termes et conditions",
  unavailabeItems: "Désolé, les articles de votre panier sont devenus indisponibles. Si vous souhaitez vérifier, ces articles indisponibles seront supprimés de votre panier.",
  updateDriverTip: "Conseil de mise à jour du pilote",
  viewMoreDetails: "Afficher plus de détails",
  "we-sent-you-sms": "NOUS VENONS DE VOUS ENVOYER UN SMS",
  welcomeBackText: "Content de te revoir",
  KfcToYourCarDesc: "Évitez les tracas de marcher dans des endroits surpeuplés. Nous viendrons à vous.",
  Order_Processing: "Traitement des commandes KFC",
  Page_Title_Login: "Connexion KFC",
  TotalOver100Text: "La commande totale de whoops est supérieure à 100 $",
  beReadyForPickup: "Soyez prêt à ramasser en magasin",
  browseMenuHeader: "Parcourir les catégories de menu",
  btnRemindMeLater: "Rappelle-moi plus tard",
  cancelButtonText: "Annuler",
  carousalDisabled: "Vue du carrousel désactivé",
  cartOffersForYou: "Offres et offres pour vous",
  cateringSchedule: "Calendrier de restauration",
  checkGiftBalance: "Vérifier le solde",
  checkInAheadTime: "Veuillez vous assurer de vérifier votre commande avant cette heure",
  checkInAtInStore: "Appuyez ci-dessous lorsque vous êtes arrivé en magasin",
  chooseAnotherWay: "Choisissez une autre façon de payer",
  chooseAnyProduct: "Choisissez l'un de ces produits",
  confirmSelection: "Confirmer la sélection",
  confirmYourOrder: "Confirmer votre commande.",
  contactInfoTitle: "Informations de contact",
  continueAsAGuest: "Continuez en tant qu'invité",
  continueToMyCart: "Continuez vers mon panier",
  createKfcAccount: "Créer un compte KFC",
  deleteConfirmMsg: "Êtes-vous sûr de vouloir supprimer cette adresse de livraison?",
  deliveryLocation: "LIEU DE LIVRAISON",
  dismissSelection: "Rejeter les sélections",
  editPersonalInfo: "Modifier les informations personnelles",
  "email-error-text": "S'il vous plaît, mettez une adresse email valide",
  "email-label-text": "Adresse e-mail*",
  emailPlaceholder: "E-mail*",
  emptyEmailErrMsg: "Entrez le courrier électronique du destinataire",
  enterYourOrderNo: "Veuillez saisir votre numéro de commande",
  estimatedArrival: "Arrivée estimée",
  estimatedarrival: "Arrivée estimée",
  favouritesHeader: "Favoris",
  feedbackHelpText: "Veuillez saisir vos commentaires.",
  "fname-error-text": "Veuillez entrer un prénom valide",
  getOccasionEmail: "Recevoir des e-mails occasionnels sur les améliorations ou les modifications du site",
  giftCardPurchase: "card-card-achat",
  giftMessageTitle: "MESSAGE",
  hasBeenConfirmed: "a été confirmé pour",
  iAmElseWhereText: "Je suis ailleurs",
  includedToppings: "Garnitures incluses",
  itemAddedToOrder: "Article (s) ajouté à la commande",
  itemNotAvailable: "Les articles de cette commande ne sont pas actuellement disponibles dans ce magasin en ce moment.",
  lastNameHelpText: "Veuillez entrer votre nom de famille",
  listviewDisabled: "ListView Disabled",
  "lname-error-text": "Merci d'entrer un nom de famille valide",
  makingOrderFresh: "Nous passons votre commande fraîche",
  maxLimitsReached: "Vous avez dépassé le nombre maximal de tentatives de code de vérification (3/3). Veuillez réessayer de vous connecter.",
  moreCrowdPleaser: "Plus de plaisirs de la foule",
  morePageSubTitle: "Titre Web",
  myPaymentMethods: "Mes méthodes de paiement",
  netbankingString: "Netbanking",
  occasionEditName: "Modifier le nom de l'ordre",
  occasionGiveName: "Ajouter la commande préférée",
  onlinePaymentMsg: "Un remboursement apparaîtra sur votre source de paiement d'origine dans les 7 à 10 jours ouvrables.",
  orderNameEditBox: "Nom de commande Box éditeur",
  orderNumberError: "Entrez votre numéro de commande [x] chiffre",
  orderReadyInJust: "ORDRE. Prêt dans Just",
  outOfStockNotify: "Désolé, les articles dans votre panier sont devenus indisponibles. Veuillez consulter avant le paiement.",
  "password-expired": "Le lien de réinitialisation du mot de passe a expiré. Veuillez réessayer.",
  pdpToastShowTime: "3000",
  phonePlaceholder: "Numéro de téléphone*",
  pickupFromWindow: "Procurez-vous votre commande dans la fenêtre Drive Thru Collection.",
  previousLocation: "Emplacement précédent",
  processingRefund: "Remboursement de traitement",
  productListModal: "Liste des produits ouverts Modal",
  rdpaccessibility: "Accessible aux fauteuils roulants",
  readyToMakeOrder: "Nous sommes prêts à passer votre commande",
  recipientEmptErr: "Email du destinataire non valide",
  removeFavourites: "Retirer des favoris",
  review_Condition: "Veuillez consulter les conditions ci-dessous.",
  scheduleDelivery: "Livraison de planification",
  searchByLocation: "Recherche par État, ville ou zip",
  seeIncludedItems: "Voir les articles inclus",
  selectOrderTitle: "Comment aimeriez-vous recevoir votre commande?",
  selectPickupTime: "Sélectionnez l’heure de prise en charge",
  signAndSaveOrder: "Inscrivez-vous et enregistrez la commande",
  signOutFailText1: "Tu es signé",
  signOutFailText2: "Veuillez vous connecter à nouveau",
  sitemapPageTitle: "Sitemap KFC",
  specificDropdown: "Peux-tu être plus précis?*",
  storeClosedError: "$ storename est actuellement fermé. Changez le magasin ci-dessous pour trouver un autre restaurant.",
  storeClosedTitle: "est actuellement fermé.",
  storeOfflineMain: "ne peut plus servir cette commande.",
  submitButtonText: "Nous faire parvenir",
  switchToDelivery: "Passer à la livraison",
  switchToTakeaway: "Changer pour ramasser",
  thanksStaticText: "Merci",
  thatDeliverToYou: "KFC qui vous livre",
  toChangeLanguage: "changer de langue",
  unselectCarryBag: "grand sac de transport non sélectionné",
  viewAllOfferText: "Voir toutes les offres",
  viewInFavourites: "Voir dans les favoris",
  viewOrderHistory: "Afficher l'historique des commandes",
  visitedDateError: "Entrez la date commandée",
  weAreWorkingYour: "Nous travaillons sur votre commande",
  Page_Title_Offers: "Offres et offres KFC",
  SignInToSeeOffers: "Connectez-vous pour voir des offres et des offres exclusives",
  addItemToCartText: "Élément ajouté au chariot",
  cancelOrderRefund: "Nous rembourserons votre paiement en totalité dans",
  cancelPickupOrder: "Êtes-vous sûr que vous souhaitez annuler votre commande de ramassage?",
  cardNickNameField: "Surnom de la carte",
  cartError_explore: "Désolé, cette nourriture est",
  cartLineItemImage: "lineitemimage",
  cashOnDeliveryMsg: "Désolé pour l'inconvénient, votre commande a été annulée par notre magasin.",
  checInAtDriveThru: "Appuyez ci-dessous lorsque vous êtes au lecteur à travers",
  closePaymentModal: "Fermez Sélectionnez votre boîte de dialogue de paiement",
  codeExpireMessage: "Votre code expirera ",
  confirmSelections: "Confirmer les sélections",
  deleteAccountText: "Votre compte a été supprimé. Tu vas me manquer.",
  deliveryPromotion: "La promotion est pour la livraison.",
  dineInStoreClosed: "Désolé, Dine-in n'est pas actuellement disponible pour le moment.",
  dismissSelections: "Rejeter les sélections",
  dobToolTipMessage: "Pour les futures récompenses d'anniversaire sur nous! Une fois enregistré, cela ne peut pas être modifié.",
  enquiryStaticText: "Veuillez nous dire plus de détails sur votre demande",
  feedbackSuccessOk: "D'ACCORD",
  findNearRestorant: "Trouvez le restaurant à proximité",
  firstNameHelpText: "Entrez votre prénom s'il vous plait.",
  fullPaymentRefund: "Vous devrez appeler notre équipe d’assistance sur {{storePhoneNumber}} pour annuler. Le paiement intégral sera remboursé dans les xx jours.",
  haveADiscountCode: "Vous avez un code de réduction?",
  inStoreCollection: "Collection en magasin",
  "input-error-email": "Un compte avec cette adresse e-mail existe peut-être déjà, veuillez vérifier l'adresse e-mail ci-dessous.",
  "invalid-otp-error": "Veuillez saisir un OTP valide. Il vous reste x tentatives",
  invalidPostalCode: "Code postal non valide",
  invalidcardNumber: "Numéro de carte invalide",
  leaveatMyDoorDesc: "Pour vous protéger, vous et notre équipe, nous pratiquons la livraison sans contact. Votre chauffeur quittera la commande à votre porte, frappera, sortez et attendra à une distance sûre pour que vous puissiez récupérer votre nourriture.",
  locationDeniedMsg: "KFC tient à traiter vos données de localisation pour trouver des restaurants à proximité, envoyer des offres, des récompenses et des actualités locales, et pour personnaliser et localiser ou utiliser une expérience utilisateur comme décrit dans notre déclaration de confidentialité.",
  loveToHearFromYou: "Nous aimerions recevoir de vos nouvelles.",
  managePreferences: "Gérer les préférences",
  "mobile-error-text": "s'il vous plaît entrer un numéro de téléphone valide",
  nameExistMsgSaved: "Le surnom d'adresse ne peut pas être le même qu'une adresse précédemment enregistrée.",
  namevalidationmsg: "les caractères spéciaux ne sont pas autorisés",
  noLongerServeText: "Ne peut plus servir cette commande.",
  noOrderHistoryMsg: "Votre seau est vide. Commençons une commande!",
  noStoreTextDineIn: "Oops! Désolé, il n'y a pas de magasins disponibles pour dîner.",
  oneCouponPerOrder: "Vous ne pouvez appliquer qu'un seul coupon par commande.",
  openProductFilter: "Filtre de produit ouvert",
  orderGettingReady: "Nous préparons votre commande",
  orderStatusUpdate: "We've updated your order status",
  otpInvalidMessage: "Code de vérification invalide",
  phoneNumberStatic: "1300 666 532",
  pleaseBeAwareThat: "VEUILLEZ NOTER QUE",
  popoverDoneButton: "Fait",
  postOrderAccepted: "Ordre accepté.",
  postOrderErrorMsg: "Il semble qu'il y ait un problème avec le statut de commande",
  preparedByHeading: "Préparé par double robinet pour activer",
  priceChangeNotify: "Les articles de votre panier ont changé le prix.",
  pushNotifications: "Notifications push",
  "quote OrderNumber": "Citez votre numéro de commande #",
  refineItemsHeader: "Affiner les articles",
  "registration-text": "Pas encore enregistré?",
  reorderFavourites: "Recevez des offres spéciales et réorganisez vos favoris",
  returnedNoResults: "retourné aucun résultat",
  saveOrderThankYou: "Merci de vous être inscrit!",
  savetoaddressbook: "Enregistrez cette adresse de livraison à votre carnet d'adresses",
  secretMenuContext: "Découvrez des friandises inédites qui n'ont jamais vu le jour - jusqu'à présent ... ce menu est mis à jour régulièrement, alors continuez à vérifier!",
  selectAnotherTime: "Select another time to receive your order.",
  selectionNotSaved: "Vos sélections ne sont pas enregistrées.",
  setManualLocation: "Installer manuellement",
  "sign-in-with-text": "ou connectez-vous avec",
  surveyScreenTitle: "Enquête",
  termsAndCondition: "termes et conditions",
  tipYourDriverDesc: "100% de votre pourboire va à votre chauffeur-livreur",
  willYouBeOrdering: "Quel menu commanderas-vous aujourd'hui?",
  yourEmailHelpText: "Veuillez saisir votre identifiant de messagerie.",
  BuildYourOwnBucket: "Construisez votre propre seau",
  Page_Order_Details: "KFC - Détails de la commande",
  Page_Title_Account: "Compte KFC",
  "Phone-number-error": "Numéro de téléphone requis pour créer et accéder à votre compte.",
  addressPlaceHolder: "Mes magasins et adresses",
  bothChangeCartMain: "PLUS disponible / n'a changé le prix.",
  bothChangeCartText: "Les articles dans votre panier sont",
  cartOffersAndDeals: "Offres et offres",
  cartRecommendTitle: "Les modules complémentaires indulgents",
  cateringPromoError: "Promotion non disponible avec les ordres de restauration",
  changeLanguageHere: "Changez votre langue ici",
  changedItemOneItem: "L'article a changé le prix.",
  checkedInAbandoned: "enregistré-abandonné",
  clearCartAwareText: "s'il te plait soit conscient de",
  codeExpiredMessage: "Votre code a expiré!",
  defaultAddressName: "Adresses",
  defaultCallMessage: "Entre-temps,",
  deliveryOptionsVal: "options de livraison",
  dineInNotAvailable: "Dine-in n'est pas disponible aimerait aller chercher à la place?",
  emptyFavouriteMenu: "Vous n'avez pas encore favorisé aucun article",
  enterYourOrderName: "Entrez le champ de saisie du nom de la commande",
  "error-email-signup": "Nous n'avons pas reçu d'e-mail de votre compte social. Veuillez réessayer de vous inscrire.",
  errorMessageClosed: "Désolé, le restaurant est fermé à la date et à l'heure que vous avez choisis. Choisissez une autre date et heure",
  favouriteMenuTitle: "FAVORIS",
  giftCardNumberText: "Numéro de carte-cadeau *",
  "invalid-email-text": "Veuillez entrer un email valide",
  invalidEmailErrMsg: "Email invalide.",
  invalidQRCodeError: "Code QR non valide, aimeriez-vous explorer le magasin KFC à proximité",
  isCheckedInCooking: "Est enregistré et cuisine",
  itemAddedToCartMsg: "Veuillez noter que vos articles seront ajoutés à votre panier.",
  "kfc-privacy-policy": "Politique de confidentialité de KFC.*",
  lastOrderCheckInAt: "Vérification de la dernière commande à",
  letUsUseUrLocation: "Veuillez nous laisser utiliser votre emplacement.",
  messageplaceholder: "Laissez un message aux destinataires ici.",
  mobileErrorMessage: "s'il vous plaît entrer un numéro de téléphone valide",
  noDeliveryErrorMsg: "Impossible de livrer à l'adresse saisie. Restaurants de livraison disponibles ci-dessous.",
  noTimeSlotsMessage: "Les installations horaires ne sont pas disponibles pour le moment",
  nutrition_allergen: "Informations sur la nutrition et les allergènes",
  openTodayWithoutAt: "Ouvert aujourd'hui",
  orderTimePassedMsg: "Sélectionnez une autre heure pour recevoir votre commande",
  "otp-account-locked": "Le code de vérification est invalide (3/3). Le compte est maintenant verrouillé.",
  "otp-reset-password": "Réinitialiser le mot de passe",
  pdpRegularSizeDesc: "Chips et boissons ordinaires",
  pdpRgularSizeTitle: "Taille régulière",
  "personal-info-text": "INFORMATIONS PERSONNELLES",
  postOrderScheduled: "programmé!",
  productUnavailable: "Produit indisponible",
  promosUnmetMessage: "Conditions promotionnelles non réalisées pour vérifier:",
  purchasefailuremsg: "Il semble qu'il y ait un problème avec l'achat de la carte-cadeau",
  quantityUpdateText: "Quantité mise à jour vers",
  readyInJustASecond: "Prêt en seulement une seconde.",
  readyToPrepareMeal: "Nous allons commencer à préparer votre repas aux doigts.",
  restaurantHandling: "Frais de livraison",
  savedAddressesText: "Adresse enregistrée",
  searchResultHeader: "résultats pour",
  seeCustomisedItems: "Voir les articles personnalisés",
  selectDeliveryTime: "Sélectionnez le délai de livraison",
  selectPickupMethod: "Choisissez votre méthode de collecte de ramassage",
  selectYourLanguage: "Choisissez votre langue",
  somethingWentWrong: "Quelque chose s'est mal passé s'il vous plaît essayez après un certain temps",
  storeCloseSoonMain: "se ferme en 45 minutes",
  storeContainerText: "Commandez des plats à emporter ou à la livraison",
  storeUseMyLocation: "Utilise ma location",
  unsupportedBrowser: "Ce navigateur n'est pas pris en charge par l'application KFC. Veuillez télécharger ces navigateurs pour utiliser cette application.",
  userRefreshWarning: "Votre session va expirer bientôt. Veuillez continuer votre travail une fois que votre page se relève",
  vehicleInformation: "Entrez les informations de votre véhicule (marque, couleur, etc.)",
  viewMapErrorButton: "Voir la carte",
  weArePreparingMeal: "Nous préparons votre repas",
  weThinkYouLoveThis: "Nous pensons que vous allez les adorer",
  MyDeliveryAddresses: "Mes adresses de livraison",
  Page_Title_Checkout: "Checkout KFC",
  Page_Title_Our_Adds: "Kfc nos ajouts",
  Page_Title_Sign_out: "Connexion KFC",
  address2Placeholder: "Appartement, suite, unité, bâtiment, sol",
  appCrashPopupHeader: "Quelque chose s'est mal passé!",
  billingAddressField: "Adresse*",
  billingAddressTitle: "ADRESSE DE FACTURATION",
  bothChangeCartQuery: "Voulez-vous garder ces paramètres?",
  cancelDeliveryOrder: "ÊTES-VOUS SÛR DE VOULOIR ANNULER VOTRE COMMANDE DE LIVRAISON ?",
  categoriesImageText: "Parcourir les catégories",
  changeOrderSettings: "Modifier les paramètres de commande",
  checkoutUnavailable: "Les articles de votre panier sont actuellement disponibles. Veuillez retirer les éléments de votre",
  clearCartActionText: "Votre chariot sera dégagé",
  "create-account-text": "S'identifier",
  createAccountToSave: "Créez un compte pour enregistrer vos commandes et vérifier plus rapidement",
  creditDebitCardText: "Carte de crédit / débit",
  defaultCallMessages: "Appelez s'il vous plaît",
  defaultErrorMessage: "Merci pour votre visite. Nous réparons cela tout de suite. Sera de retour bientôt.",
  deleteOccassionText: "Supprimer cette occasion",
  deliveryAddressText: "ADRESSE DE LIVRAISON",
  deliveryInstruction: "Veuillez saisir les instructions de livraison",
  deliveryStoreClosed: "Désolé, la livraison n'est pas actuellement disponible pour le moment.",
  dismissChangesAlert: "Vos sélections ne sont pas enregistrées.",
  doubleTapToActivate: "Double Tap pour activer",
  driveThruCollection: "Collection de conduite",
  editItemSuccessText: "Vous avez réussi à éditer un article dans votre panier.",
  emptyFullNameErrMsg: "Entrez votre nom complet.",
  emptyLastNameErrMsg: "Entrez votre nom de famille.",
  emptyYourNameErrMsg: "S'il vous plaît entrez votre nom.",
  enquiryDetailsError: "Entrez les détails de la demande",
  enterContactDetails: "Entrez les coordonnées",
  "exceeeded-limit-msg": "Vous avez dépassé le nombre maximal de tentatives de code de vérification (3/3).",
  favoriteItemMessage: "Article ajouté aux favoris",
  favouriteNameUpdate: "Nom préféré mis à jour",
  findClosestLocation: "Trouvez votre emplacement le plus proche.",
  foundDeliveryDriver: "Nous avons trouvé un chauffeur",
  giftCardInformation: "Informations sur la carte-cadeau",
  giftCardPurchageMsg: "Votre carte-cadeau a été achetée et les détails envoyés par e-mail au destinataire",
  iAmAtDriveThruQueue: "Je suis à la ligne du lecteur",
  iAmInsideRestaurant: "Je suis à l'intérieur du restaurant",
  iWillPayWhenIPickUp: "Je paierai quand je viendrai chercher",
  insufficientBalance: "Solde insuffisant",
  lastNamePlaceHolder: "Nom de famille*",
  legalInfoPLPFooter1: "L’apport énergétique quotidien moyen pour une adulte canadienne est de 8700kJ",
  legalInfoPLPFooter2: "^ Pepsi Freeze & Mountain Dew Freeze contient de la caféine. Mountain Dew Freeze n’est pas recommandé pour les enfants, les femmes enceintes ou allaitantes ou les personnes sensibles à la caféine.",
  locationDeniedTitle: "Veuillez nous laisser utiliser votre emplacement.",
  noStoreTextTakeaway: "Oops! Désolé, il n'y a pas de magasins disponibles pour ramasser.",
  occassionNameExists: "Le nom d'occasion existe déjà",
  onChangeWelcomeBack: "Content de te revoir!",
  paymentSectionTitle: "PAIEMENT PAR",
  pdpAllergyNutrition: "Allergie et informations nutritionnelles",
  phcWheelChairAccess: "Accès en fauteuil roulant",
  pleaseEnterLocation: "Veuillez saisir votre emplacement",
  postOrderErrorMsgAU: "Hmm, quelque chose n'a pas fonctionné à la caisse. Vérifiez les détails de votre mode de paiement et réessayez.",
  quantityDecreseText: "Diminue la quantité de 1 élément pour",
  readyToStartCooking: "Vous êtes sûr que vous êtes prêt à commencer à cuisiner?",
  removeFromFavourite: "Retirer du favori",
  rescheduleOrderTime: "order time has passed",
  savedeliveryaddress: "Enregistrer l'adresse de livraison",
  scheduleTimeCrossed: "L'heure de votre commande\n prévue est passée",
  scheduledTimePassed: "L'heure prévue est passée, veuillez sélectionner une nouvelle heure pour continuer.",
  seeFullOrderHistory: "Voir l'historique complet des commandes",
  selectOrderSubTitle: "La disponibilité et les prix du menu peuvent varier entre les types de commandes.",
  signInToYourAccount: "Connectez-vous à votre compte",
  sitTightCallOutText: "Asseyez-vous serré, nous appellerons votre nom quand il sera prêt",
  socialNetworkingBtn: "Site de réseautage social",
  splahScreenGreeting: "RAVI DE VOUS RENCONTRER",
  storeOfflineContent: "Veuillez trouver un autre restaurant à proximité.",
  takeawayStoreClosed: "Désolé, le ramassage n'est pas actuellement disponible pour le moment.",
  toCompleteThisOrder: "POUR CHANGER LA LANGUE.",
  unavailableCartMain: "PLUS DISPONIBLE",
  unavailableCartText: "Désolé, certains articles sont",
  unsuccessfulPayment: "Il semble qu'il y ait un problème avec le statut de commande",
  usernameplaceholder: "Votre nom*",
  verificationMessage: "Veuillez saisir le code de vérification que nous venons d'envoyer:",
  Page_Title_ContactUs: "KFC Contactez-nous",
  Page_Title_Gift_Card: "Carte-cadeau KFC",
  Page_Title_Not_Found: "Page KFC introuvable",
  "account-header-title": "CRÉER UN COMPTE",
  addGiftCardOrVoucher: "Ajouter un coupon",
  addNewCardButtonText: "Nouvelle carte de crédit/débit",
  allergenTraceDetails: "L'allergène est stocké ou utilisé pour fabriquer d'autres articles sur le site où le produit (ou l'un de ses ingrédients) est produit.",
  cateringCartErrorMsg: "Les commandes de restauration nécessitent un avis d'avance 24 heures sur 24.",
  changeYourOrderTitle: "Changez votre commande",
  clearSearchOrderName: "Effacer le bouton Nom de la commande de recherche",
  confirmTextContinued: "et utilisez cette méthode pour vous connecter à l'avenir.",
  currentlyUnavailable: "actuellement indisponible",
  deleteAccountMessage: "Êtes-vous sûr de vouloir supprimer votre compte",
  deliveryInstructions: "Entrez les instructions de livraison (facultatif)",
  dispositionUnavalMsg: "Désolé,% Disposition% n'est actuellement pas disponible. Veuillez modifier les paramètres de votre commande ci-dessous pour terminer votre commande.",
  editorPickupSubTitle: "Recevez des mises à jour de l'éditeur sur les versions nouvelles et à venir et les meilleures critiques de clients comme vous",
  emptyFirstNameErrMsg: "Entrez votre prénom.",
  errorMessageInactive: "Condamner! Nous ne pouvons pas consulter votre commande, continuer à essayer ou alternativement, veuillez visiter le magasin.",
  favoriteStoreMessage: "Ce magasin est marqué comme votre préféré",
  findNearByRestaurant: "Trouvez le restaurant à proximité",
  firstNamePlaceholder: "Prénom*",
  "forgot-password-text": "Mot de passe oublié?",
  invalidAddressHeader: "Désolé, nous n'avons pas pu identifier votre adresse. Veuillez être plus précis avec votre emplacement.",
  largeCarryBagContent: "5,00 ₹ Tick pour ajouter un grand sac de transport.",
  "last-name-label-text": "Nom de famille*",
  lastNameErrorMessage: "Veuillez saisir un nom de famille valide",
  locationBlockedError: "Vous avez bloqué de KFC à accéder à votre emplacement. Accédez à vos paramètres de navigateur et activez% kfcurl% pour utiliser mon emplacement.",
  "login-reset-password": "Reset password",
  mobileToolTipMessage: "Numéro de téléphone requis pour la messagerie basée sur le service autour de votre commande.",
  myFavouriteMenuTitle: "Mon menu préféré",
  nonAlaCarteAlertLink: "Voir le guide de la nutrition et des allergènes",
  nonAlaCarteAlertText: "Voir les produits individuels de ce repas pour des informations sur les allergènes",
  optionalEmailAddress: "Adresse e-mail",
  orderTakeAwayBtnText: "Commander la ramassage",
  orderTimePassedTitle: "L'HEURE DE VOTRE COMMANDE PREVUE EST PASSEE",
  pickupCancalledOrder: "Votre commande de prise en charge a été annulée.",
  priceChangedCartMain: "Prix modifié.",
  priceChangedCartText: "Les articles dans votre panier ont",
  quantityIncreaseText: "Augmente la quantité de 1 élément pour",
  reviewBillingAddress: "Veuillez vérifier votre adresse de facturation",
  saveToFavouriteOrder: "Économisez sur les commandes préférées",
  savedDeliveryAddress: "Enregistré votre adresse de livraison",
  savedDeliveryOptions: "Options de livraison",
  scheduleForYourOrder: "Planification de votre commande",
  selectDifferentStore: "Veuillez sélectionner un autre restaurant ou continuer à parcourir le menu",
  selectYourBankHeader: "Sélectionnez votre banque",
  suggestedSearchTerms: "Aborder les suggestions",
  surveyScreenQuestion: "Comment était votre commande?",
  takeawayNotAvailable: "Ramasser n'est pas disponible, je voudrais aller chercher du dîner à la place?",
  "terms-and-conditions": "En continuant, j'accepte les",
  tipAddedToastMessage: "Astuce ajoutée ! Votre chauffeur va adorer",
  unableToValidateCard: "Nous n'avons pas pu valider votre carte",
  unavailableCartQuery: "À cet endroit. Voulez-vous garder ces paramètres?",
  unavailableUppercase: "INDISPONIBLE",
  useMyLocationBtnText: "Utilise ma location",
  useremailplaceholder: "Votre e-mail *",
  userphoneplaceholder: "Votre numéro de téléphone*",
  verificationOTPLabel: "Code de vérification",
  willBeReadyForPickup: "Sera prêt pour le ramassage par",
  Page_Title_Post_Order: "KFC Post Order",
  Page_Title_TermsOfUse: "Conditions d'utilisation de KFC",
  accountSignOutMessage: "Êtes-vous sûr de vouloir vous déconnecter de votre compte?",
  addHopeSubDescription: "Notre objectif est de nourrir 20 millions de repas d'ici 2021.",
  addedToYourFavourites: "Ajouté à vos favoris",
  addresss2InvalidError: "Les caractères spéciaux ne sont autorisés que, / # @ - ().",
  apiFailurePopupHeader: "Quelque chose s'est mal passé!",
  billingPostalCodeText: "Code postal de facturation*",
  callSupportButtonText: "Appeler l'assistance",
  canNotDeliverErrorMsg: "Impossible de livrer à l'adresse saisie. Restaurants de livraison disponibles ci-dessous.",
  cancelOrderButtonText: "annuler la commande",
  checkGiftBalanceTitle: "Vérifiez le solde de votre carte-cadeau",
  checkedInNotCollected: "checkin-not_collected",
  clearCartCompleteText: "Pour terminer cette commande.",
  confirmYouAreHereText: "Nous allons commencer à préparer votre commande maintenant, alors assurez-vous que vous êtes ici ou très près!",
  "different-number-text": "Numéro différent ?",
  editCurrentRestaurant: "Modifiez votre restaurant KFC",
  editSelectionsBtnText: "Modifier les sélections",
  exampleModalLongTitle: "COURRIEL NON REÇU",
  "first-name-label-text": "Prénom*",
  firstNameErrorMessage: "Veuillez entrer un prénom valide",
  inlineSavedAddressMsg: "Il y a déjà une adresse enregistrée avec ce nom.",
  "invalid-password-text": "Entrer un mot de passe valide s'il vous plait",
  invalidFullNameErrMsg: "Nom complet non valide.",
  invalidLastNameErrMsg: "Nom de famille non valide.",
  keepPrevOrderSettings: "Souhaitez-vous garder votre paramètre de commande précédent?",
  maxOrderAmountMessage: "Le montant de la commande maximale pour le magasin est",
  maxVerificationLimits: "Vous avez dépassé le nombre maximal de tentatives de code de vérification (3/3).",
  minOrderAmountMessage: "Le montant de la commande min pour le magasin est",
  myFavouriteBrowseMenu: "Parcourir le menu",
  notAbleToValidateCard: "NOUS N'AVONS PAS PU VALIDER VOTRE CARTE",
  openTomorrowWithoutAt: "Ouvrir demain",
  otpCodeExpiredMessage: "Votre code a expiré!",
  paymentTermsOfUseText: "Consultez nos Conditions d'utilisation et Confidentialité.",
  pleaseReviewYourOrder: "Veuillez consulter votre commande",
  priceChangedCartQuery: "Voulez-vous garder ces paramètres?",
  purchasefailureheader: "OH NON!",
  saveCardMandatoryNote: "*Ces champs sont nécessaires pour continuer.",
  searchDiffAddressText: "Rechercher une adresse différente",
  storeCloseSoonContent: "Complétez votre commande et vérifiez dans \n  15 minutes ou trouvez un autre magasin à proximité.",
  storeClosedButtonText: "Magasin fermé",
  testingLingualSupport: "Anglaise",
  tippingInvalidMessage: "Veuillez entrer une entrée valide",
  unFavoriteItemMessage: "Article supprimé des favoris",
  "use-different-no-text": "UTILISER UN NUMÉRO DIFFÉRENT",
  wantToKnowPlaceholder: "Tapez votre message ici.",
  yourCartWillBeCleared: "VOTRE PANIER SERA VIDÉ",
  yourCateringOrderWill: "Votre commande de restauration sera",
  NoBasketIdErrorMessage: "Nous n'avons pas pu récupérer les détails de votre panier en raison d'une erreur inattendue. Pour continuer davantage, veuillez sélectionner le magasin pour continuer.",
  OccasionNameValidation: "Le nom ne peut pas contenir de caractères spéciaux",
  PercentDailyValuesText: "* L'apport quotidien moyen adulte est de 8700kj.",
  "account-locked-message": "L'adresse e-mail ou le mot de passe est invalide (3/3). Le compte est maintenant verrouillé.",
  addPaymentMethodHeader: "Ajouter le mode de paiement",
  allergenPresentDetails: "L'allergène est présent dans le produit en tant qu'ingrédient, additif alimentaire ou aide à la transformation.",
  callOutWhenMealIsReady: "Nous appellerons votre nom lorsque votre repas à lécher les doigts sera prêt.",
  cardDeleteConfirmation: "Voulez-vous vraiment supprimer cette carte de votre compte ?",
  cartCouponErrorMessage: "Désolé, ce code n'est pas disponible pour le moment.",
  cateringClosedStoreMsg: "Euh oh, on dirait que ce magasin KFC a fermé, vous ne pourrez donc pas commander ici maintenant.",
  cateringToMenuNavTitle: "Juste une tête rapide",
  connectWithASpecialist: "Connectez-vous avec un spécialiste pour obtenir des réponses.",
  deliveryAddressDeleted: "Adresse de livraison supprimée",
  emptyPhoneNumberErrMsg: "Entrez votre numéro de téléphone.",
  feedbackSuccessMessage: "Merci d'avoir soumis votre requête. Nous reviendrons bientôt.",
  giftcardpaymentfailure: "Malheureusement, nous ne pouvons pas traiter ce paiement, car le paiement a été refusé par votre émetteur de carte de crédit ou votre banque",
  induldentAddOnsHeading: "Nous pensons que vous allez aussi aimer cela ...",
  invalidFirstNameErrMsg: "Prénom invalide.",
  "kfc-vip-marketing-text": "VIPᵀᴹ",
  locationDifferentError: "Cette commande précédente et votre emplacement actuel sont différents, sélectionnez Changer pour mettre à jour votre restaurant KFC ci-dessous.",
  menuToCateringNavTitle: "Juste une tête rapide",
  myFavouriteMenuNoItems: "Vous n'avez pas encore favorisé aucun article",
  myOccassionUnavailable: "Vous n'avez pas encore ajouté de commandes préférées",
  "oneNum-validation-text": "Un nombre",
  orderNoLongerCheckedIn: "Cette commande ne peut plus être vérifiée.",
  orderNumberPlaceHolder: "Numéro de commande*",
  pickupInsideRestaurant: "Procurez-vous votre commande au comptoir à l'intérieur du restaurant",
  placePinAtYourLocation: "Placez la broche à votre emplacement.",
  "postal-code-error-text": "Veuillez entrer un code postal valide",
  "postal-code-label-text": "Code postal",
  postalcodeErrorMessage: "Veuillez entrer un code postal canadien valide",
  removeFromFavOrdersMsg: "Êtes-vous sûr de supprimer cette commande de vos favoris?",
  returnToPayemntOptions: "Retour aux options de paiement",
  returnToPaymentOptions: "Retour aux options de paiement",
  selectYourWalletHeader: "Sélectionnez votre portefeuille",
  storeClosedServerTitle: "ne peut plus servir cette commande.",
  subscribedToastMessage: "Vous vous êtes enregistré avec succès",
  thankYouCommentMessage: "Vos commentaires ont été reçus et nous vous répondrons sous peu",
  tickToAddLargeCarryBag: "Cochez pour ajouter un grand sac de transport.",
  tippingExceededMessage: "Votre pourboire ne doit pas dépasser les valeurs de votre commande",
  totalPriceErrorMessage: "Oups La commande totale est supérieure à $",
  unFavoriteStoreMessage: "Ce magasin est supprimé de vos favoris",
  weAreConfirmingPayment: "Nous confirmons le paiement et votre commande",
  addressNickNameOptional: "Adressez le surnom (facultatif)",
  addressSuggestionHeader: "Cette adresse semble-t-elle correcte?",
  cartCateringContentText: "Veuillez sélectionner une heure ou une date ultérieure, ou contactez le magasin par téléphone.",
  checkoutNoSignInMessage: "Veuillez vous connecter ou vous inscrire ci-dessus pour ajouter un mode de paiement et un paiement.",
  closeStoreModelSubTitle: "Veuillez sélectionner un autre magasin ou commander pendant les heures de travail.",
  completeOrderButtonText: "Complétez la commande",
  continueAsGuestCheckout: "Continuez en tant qu'invité",
  "create-account-password": "Mot de passe",
  dineInPickDifferentTime: "Dine-in n'est pas disponible pour l'heure sélectionnée, veuillez sélectionner différentes heures.",
  "edit-Phone-number-error": "Veuillez saisir un numéro de téléphone portable australien valide et cliquer sur Enregistrer. Vous recevrez ensuite un autre code d'accès unique par SMS pour terminer la connexion.",
  emergencyStoreCloseMain: "est actuellement fermé en raison de circonstances imprévues",
  emptySearchResultHeader: "Votre recherche ne s'est pas terminée dans aucun résultat",
  enterDifferentOrderName: "Il y a déjà un autre favori avec ce nom. Entrez un nom de commande différent.",
  invalidCharactersErrMsg: "Les chiffres et les caractères spéciaux ne sont pas autorisés.",
  invalidYourEmailErrText: "Veuillez saisir l'adresse e-mail correcte",
  locationDeniedTitleCaps: "Veuillez nous laisser utiliser votre emplacement.",
  lookingForSpecificOrder: "Vous cherchez une commande spécifique?",
  "ma-email-address-exists": "Cette adresse e-mail a déjà un compte KFC",
  mobileNumberWithAstrick: "Numéro de portable*",
  networkIssuePopupHeader: "Quelque chose s'est mal passé!.",
  "new-password-label-text": "Nouveau mot de passe*",
  orderTypeDifferentError: "Cette commande précédente était $ précédemment OrderType et votre session actuelle est pour $ CurrentOrderType, sélectionnez Changer pour mettre à jour si nécessaire ci-dessous.",
  pickupPickDifferentTime: "La prise en charge n'est pas disponible pour l'heure sélectionnée, veuillez sélectionner différentes heures.",
  saveCardForFastCheckout: "Enregistrez la carte pour un paiement plus rapide",
  savedAddressHeaderTitle: "Mes magasins et adresses",
  savedOrderScheduleOrder: "Commande prévue",
  searchNutritionAllergen: "Guide de recherche de nutrition et d'allergène",
  surveyScreenSubQuestion: "Écrire une critique",
  "terms-of-use-text-part1": "En créant un compte, j’accepte le",
  "terms-of-use-text-part3": "et comprendre que mes informations seront utilisées comme décrit sur cette page et le",
  weveFoundDeliveryDriver: "Nous avons trouvé un chauffeur",
  Page_Title_Cart_Checkout: "Checkout KFC",
  addressValidationFailied: "La validation de l'adresse a échoué",
  appCrashPopupDescription: "Oups, quelque chose s'est mal passé! Veuillez redémarrer l'application",
  cannotContainSpecialChar: "Le nom ne peut pas contenir de caractères spéciaux.",
  cartCateringAlertEndText: "à consulter",
  cartSelectDifferentStore: "Veuillez trouver un autre restaurant à proximité.",
  communicationPreferences: "Préférences de communication",
  "date-of-birth-label-text": "Date de naissance",
  deliveryAddressLineLabel: "APT / Suite / Floor (facultatif)",
  deliveryPartnersDoordash: "doordash",
  editOccassionDialogTitle: "Modifier le nom de l'occasion",
  enterQuestionPlaceholder: "| Entrez la question ou le terme de recherche",
  enterYourDeliveryAddress: "Entrez votre adresse de livraison",
  favouriteNameLengthError: "Le nom préféré doit être au moins 3 charnières",
  invalidCustomerInfoError: "Détails du client non valides. Veuillez le mettre à jour à partir de la page des paramètres du compte.",
  invalidPhoneNumberErrMsg: "Numéro de téléphone invalide.",
  itemCurrentlyUnavailable: "Article actuellement indisponible",
  "kfc-marketing-text-part1": "J’aimerais être un KFC",
  "kfc-marketing-text-part2": "pour recevoir des offres exclusives et des mises à jour du colonel aux coordonnées énumérées ci-dessus. Vous pouvez vous désabonner à tout moment.*",
  kfcSignInExclusiveOffers: "Connectez-vous pour voir des offres et des offres plus exclusives",
  kfcSignInExclusivePromos: "Connectez-vous pour voir des promotions et des récompenses exclusives",
  "mobile-number-label-text": "Numéro de portable*",
  noPaymentOptionAvailable: "Aucune option de paiement disponible.",
  noStoresWithDineInHeader: "Désolé, Dine-in n'est pas actuellement disponible pour cette adresse.",
  noStoresWithPickupHeader: "Désolé, le ramassage n'est pas actuellement disponible pour cette adresse.",
  "nutration-allergen-guide": "Guide de nutrition et d'allergène",
  payOnArrivalCheckboxDesc: "Assurez-vous d'avoir le montant correct \npour votre chauffeur car la monnaie est limitée.",
  phonenumberEmptyHelpText: "Veuillez entrer votre numéro de téléphone.",
  promosRemoveConfirmation: "Êtes-vous sûr de vouloir supprimer cette promotion?",
  promosRemoveToastMessage: "Promo supprimé de la commande",
  promosSuceesToastMessage: "Promo ajouté à votre commande",
  receiveSpecialOffersText: "Recevez des offres spéciales et réorganisez vos favoris",
  removeAllUnavailableItem: "Supprimer tous les éléments indisponibles",
  reviewCardBillingDetails: "Veuillez vérifier les détails de votre carte et de votre adresse de facturation.",
  savedOrderInFavoriteMenu: "J'ai enregistré cette commande dans mon menu préféré.",
  "spclChar-validation-text": "Un caractère spécial",
  totalOrderErrorOverlimit: "Whoops Total Order est terminé",
  unsubscribedToastMessage: "Vous avez désabonné avec succès",
  wereMakingYourOrderFresh: "Nous passons votre commande fraîche",
  wereReadyToMakeYourOrder: "Nous sommes prêts à passer votre commande",
  IsOnHisWayToTheRestaurant: "est en route vers le restaurant",
  Page_Title_Payment_Status: "Statut de paiement KFC",
  Page_Title_Privacy_Policy: "Politique de confidentialité de KFC",
  addContactToEnablePayment: "Veuillez ajouter vos coordonnées ci-dessus pour permettre l'ajout d'un mode de paiement.",
  cancelDeliveryOrderRefund: "Votre commande sera remboursée en totalité dans les 7 jours ouvrables",
  cateringConfirmationEmail: "Un e-mail de confirmation a été envoyé et un directeur de magasin vous contactera le jour de la prise en charge pour vous assurer qu'il est cuisiné au bon moment",
  "create-account-login-text": "Créer un compte",
  deleteAddressConfirmation: "Êtes-vous sûr de vouloir supprimer l'adresse de livraison?",
  deleteDeliverySaveAddress: "Adresse de livraison supprimée",
  deliveryPickDifferentTime: "La livraison n'est pas disponible pour l'heure sélectionnée, veuillez sélectionner différentes heures.",
  doubleTaptoStartYourOrder: "Double appuyez pour ouvrir Démarrer votre page de commande",
  giftcardCheckbalnaceTitle: "Vérifiez le solde de votre carte-cadeau",
  invalidPhoneNumberErrText: "Pas un numéro de téléphone valide",
  invalidVehicalInformation: "Informations sur les véhicules non valides",
  "lowercase-validation-text": "Une lettre minuscule",
  multipleCustomizationText: "Cet élément a plusieurs personnalisations ajoutées. Procéder au panier pour supprimer l'article?",
  payOnArrivalCheckboxLabel: "Payer en espèces à l'arrivée",
  "personal-info-header-text": "AJOUTER DES INFORMATIONS PERSONNELLES",
  pleaseEnterAValidLastName: "Veuillez saisir un nom de famille valide",
  postProcessIngGstIncluded: "Total (TPS inclus):",
  promosUnmetSummaryMessage: "Conditions promotionnelles non remplies, consultez les promo (s dans le panier pour plus de détails.",
  recipientemailplaceholder: "Destinataire E-mail*",
  "registration-text-account": "Vous avez déjà un compte?",
  rescheduleOrderTimeButton: "Reprogrammer",
  storeClosePickupOrderMode: "Ramasser dans ce magasin n'est actuellement pas disponible, passer à la livraison pour ce magasin pour remplir votre commande.",
  storeUnavailableForPickup: "Ramasser dans ce magasin n'est actuellement pas disponible, passer à la livraison pour ce magasin pour remplir votre commande.",
  storesNotServingCurrently: "Désolé! Votre boutique ne sert pas de commandes actuellement",
  "uppercase-validation-text": "Une lettre majuscule",
  valideDayAndMonthRequired: "Jour valide, un mois doit soumettre",
  "Forgot-Password-Email-info": "Si un compte existe pour cette adresse e-mail, recherchez-y un lien avec les étapes suivantes pour réinitialiser votre mot de passe.",
  Page_Title_Payment_Failure: "Échec du paiement KFC",
  Page_Title_Payment_Success: "Succès du paiement KFC",
  apiFailurePopupDescription: "Oups, quelque chose s'est mal passé! Veuillez réessayer.",
  cartCateringAlertStartText: "Désolé, les commandes de restauration nécessitent un préavis de 24 heures",
  checkoutUnavailableAtStore: "Paiement actuellement indisponible dans ce magasin",
  createAndAccountSaveOrders: "Créez un compte pour enregistrer vos commandes et",
  dineInNoStoresFoundMessage: "Aucun restaurant n'a été trouvé pour le dîner. Veuillez essayer un autre endroit.",
  dineInUnavailableErrorText: "Dine-in n'est actuellement pas disponible pour votre emplacement. Souhaitez-vous commander des ramassages à la place?",
  "edit-Phone-number-error-CA": "Veuillez entrer un numéro de téléphone mobile canadien valide et cliquer sur « Enregistrer ». Vous recevrez ensuite un autre code d’accès à usage unique par SMS pour terminer la connexion.",
  emergencyStoreCloseContent: "Trouvez un autre restaurant à proximité ou \n  près de continuer à parcourir le menu",
  invalidDeliveryInstruction: "Instruction de livraison non valide",
  invalidPhoneErrforGiftCard: "Numéro de téléphone non valide, veuillez saisir le numéro de téléphone valide",
  noStoresWithDeliveryHeader: "Désolé, la livraison n'est pas actuellement disponible pour cette adresse.",
  paymentPreValidationFailed: "Malheureusement, nous ne sommes pas en mesure de traiter votre paiement dès maintenant. Veuillez essayer avec une autre option de paiement.",
  pickupNoStoresFoundMessage: "Aucun restaurant n'a été trouvé pour le transport. Veuillez essayer un autre endroit.",
  pleaseEnterAValidFirstName: "Veuillez entrer un prénom valide",
  removedFromFavouriteStores: "Retiré des magasins préférés",
  saveOrderAndCheckoutFaster: "Économisez vos commandes et vérifiez plus rapidement",
  "send-you-otp-on-email-text": "Nous enverrons un code de vérification à votre adresse e-mail :",
  someoneElseCollectingOrder: "Quelqu'un d'autre collectionne la commande?",
  unidentifiedAddressMessage: "Désolé, nous n'avons pas pu identifier votre adresse. Veuillez être plus précis en déplaçant la carte.",
  Page_Title_Terms_Conditions: "Termes et conditions KFC",
  cateringToMenuNavContentMsg: "Cela mettra fin à votre commande de restauration et vous amènera au menu ordinaire pour démarrer une nouvelle commande. Tous les éléments de menu de restauration dans votre panier seront supprimés.",
  "char-length-validation-text": "10 à 15 caractères",
  clickPlaceOrderConfirmAgree: "En cliquant sur une commande de place, vous confirmez que vous acceptez notre",
  closeStoreModelSubNearTitle: "Veuillez trouver un autre restaurant à proximité.",
  "confirm-password-label-text": "Confirmer le nouveau mot de passe*",
  "current-password-error-text": "Mot de passe introuvable",
  "current-password-label-text": "Confirmez le mot de passe*",
  dispositionItemNotAvailable: "Non disponible pour",
  enterYourOrderNoPlaceHolder: "Entrez votre numéro de commande",
  freeDeliverywithWickedWings: "Livraison gratuite avec des ailes méchantes",
  induldentAddOnsAddedMessage: "Article ajouté à votre commande",
  maxSavedCardLimitWarningMsg: "Vous avez atteint votre maximum de cartes enregistrées. Veuillez supprimer pour en ajouter un autre.",
  menuKickedInUnavailableCart: "Le menu du midi est lancé",
  menuToCateringNavContentMsg: "Cela mettra fin à votre commande actuelle et vous amènera au menu de restauration pour démarrer une commande de restauration. Tous les articles actuellement dans votre panier seront supprimés.",
  "password-reset-successfully": "Votre mot de passe a été réinitialisé. Connectez-vous à votre compte en utilisant votre nouveau mot de passe.",
  previousOrderDataSettingMsg: "Souhaitez-vous garder votre paramètre de commande précédent?",
  recipientEmptyEmailHelpText: "Veuillez saisir l'ID de messagerie du destinataire.",
  reviewCardAndBillingAddress: "Veuillez vérifier les détails de votre carte et de votre adresse de facturation",
  selectPaymentMethodToastMsg: "Sélectionnez le mode de paiement pour continuer",
  selectYourOtherWalletHeader: "Sélectionnez votre autre portet",
  storeCloseDeliveryOrderMode: "La livraison de ce magasin n'est actuellement pas disponible, changez pour récupérer pour ce magasin pour remplir votre commande.",
  storeClosedAndPickUpApplied: "Le magasin est actuellement fermé, la prochaine heure de retrait disponible a été appliquée",
  storeUnavailableForDelivery: "La livraison de ce magasin n'est actuellement pas disponible, changez pour récupérer pour ce magasin pour remplir votre commande.",
  takeAwayUnavalibleErrorText: "Ce KFC n'accepte pas les commandes en ligne. Veuillez essayer un autre KFC près de chez vous ou revenir plus tard.",
  totalOrderErrorBetweenlimit: "Whoops La commande totale n'est pas entre",
  cartRemoveSingleItemNextText: "de votre panier?",
  cartRemoveSingleItemPrevText: "Êtes-vous sûr de supprimer",
  deeplinkCategoryNotAvailable: "Désolé, CETTE CATÉGORIE N'EST PAS DISPONIBLE POUR LE RESTAURANT SÉLECTIONNÉ.",
  deliveryNoStoresFoundMessage: "Hé, le magasin KFC le plus proche de votre emplacement n'accepte actuellement pas les commandes en ligne. Veuillez essayer un autre emplacement ou vérifier à nouveau plus tard.",
  deliveryUnavailableErrorText: "La livraison n'est actuellement pas disponible pour votre emplacement. Souhaitez-vous commander des ramassages à la place?",
  "exceeded-max-limit-error-msg": "Vous avez dépassé le nombre maximal de tentatives de code de vérification (3/3). Veuillez réessayer de vous inscrire.",
  exceededVerificationAttempts: "Vous avez dépassé les tentatives de code de vérification maximales (3/3). Les informations n'ont pas été enregistrées.",
  infoMakeSureRightNumberEmail: "Veuillez vous assurer que c'est le bon numéro et l'adresse e-mail, juste au cas où nous devons vous contacter pour cette commande. Nous ne vous spammerons pas, promettez.",
  invalidRecipientEmailErrText: "Veuillez saisir l'adresse e-mail correcte",
  networkIssuePopupDescription: "Nous sommes désolés, nous avons des problèmes avec votre connexion. Veuillez vérifier votre service wifi ou mobile et réessayer.",
  removeUnavailableItemsInCart: "supprimer les articles indisponibles dans le panier",
  storeClosedTimeAppliedPickup: "Ce magasin est actuellement fermé, la prochaine heure de ramassage disponible a été appliquée",
  suggestionlocationTextPickup: "Emplacements suggérés",
  useDeliveryAddressForBilling: "Utiliser l'adresse de livraison comme adresse de facturation",
  areYouSureToDeleteAccountText: "Êtes-vous sûr de vouloir supprimer votre compte?",
  cartRemoveAllConfirmationtext: "Êtes-vous sûr de supprimer tous les articles dans votre panier?",
  "duplicate-password-error-text": "L'ancien et le nouveau mot de passe ne doivent pas être identiques",
  hasAcceptedToDeliverYourOrder: "a accepté de livrer votre commande",
  "password-not-match-error-text": "La saisie du mot de passe doit correspondre à la saisie précédente",
  selectYourPaymentScreenHeader: "Sélectionnez votre paiement",
  valideDayMonthAndYearRequired: "Le jour, le mois et l'année valides sont tenus de soumettre",
  deliveryIsCurrentlyUnavailable: "La livraison n'est pas disponible actuellement",
  globalPaymentFailedScreenTitle: "NOUS N'AVONS PAS PU VALIDER VOTRE CARTE",
  storeClosedTimeAppliedDelivery: "Ce magasin est actuellement fermé, le prochain délai de livraison disponible a été appliqué",
  cartError_sorryFoodNotAvailable: "Actuellement, continuez à explorer.",
  globalPaymentFailedScreenHeader: "OPTIONS DE PAIEMENT SAUVEGARDÉES",
  noStoresWithDeliveryHeaderError: "La livraison n'est actuellement pas disponible pour votre emplacement entré. Pourriez-vous être plus précis avec l'adresse ou aimeriez-vous essayer de ramasser à la place?",
  cartEditLineItemConfirmationtext: "Vous avez réussi à éditer un article dans le panier.",
  globalPaymentFailedScreenBtnText: "Retour aux modes de paiement",
  globalPaymentFailedScreenSubTitle: "Veuillez vérifier les détails de votre carte et de votre adresse de facturation.",
  loremIpsumDolorSitAmetConjuncivus: "Lorem ipsum Dolor Sit Amet conjoncivus",
  pleaseEnterYourVehicalInformation: "Veuillez saisir les informations de votre véhicule",
  cartRemoveLineItemConfirmationtext: "L'article a été supprimé de votre panier.",
  takeAwayUnavalibleErrorTextWithCTA: "La récupération n'est actuellement pas disponible pour votre emplacement. Souhaitez-vous essayer une adresse différente?",
  addressBoxPlaceHolderForSearchStore: "Recherche par banlieue ou code postal",
  deliveryUnavailableErrorTextWithCTA: "Désolé, nous n'avons pas pu identifier votre adresse. Veuillez être plus précis avec votre emplacement.",
  dineInStoresWithoutAnyServiceHeader: "Désolé, Dine-in n'est pas actuellement disponible pour le moment. Souhaitez-vous planifier plus tard?",
  informToContactNominatedPersonOrder: "Nous n'utiliserons ces informations que pour contacter la personne désignée sur la commande.",
  pickupStoresWithoutAnyServiceHeader: "Désolé, le ramassage n'est pas actuellement disponible pour le moment. Souhaitez-vous planifier plus tard?",
  deliverystoresWithoutAnyServiceHeader: "Désolé, la livraison n'est pas actuellement disponible pour le moment. Souhaitez-vous planifier plus tard?",
  itsBusyAndItsTakingAWhileToFindADriver: "C'est occupé et cela prend un certain temps pour trouver un chauffeur ...",
  cartEditLineItemConfirmationtextMessage: "Vous avez réussi à éditer un article dans votre panier.",
  orderScheduled: "ORDER SCHEDULED",
  goodMorning: "Good Morning",
  goodAfternoon: "Good Afternoon",
  noKfcNearYou: "Sorry, there is no KFC near you",
  meetAtVehicle: "Rendez-vous au véhicule",
  couponErrMsgBSDE0022: "Ce code promo est déjà utilisé.",
  couponErrMsgBSBR003: "Ce code promo est incorrect.",
  monday: "lundi",
  tuesday: "mardi",
  wednesday: "mercredi",
  thursday: "jeudi",
  friday: "vendredi",
  saturday: "samedi",
  sunday: "dimanche",
  editAddress: "MODIFIER L'ADRESSE DE LIVRAISON",
  thereNoFriedText: "IL N'Y A PAS DE FRIT",
  chickenOnThisPage: "POULET SUR CETTE PAGE...",
  giftCardPurchaseSuccess1: "YOUR GIFT CARDS",
  giftCardPurchaseSuccess2: "ARE ON THE WAY",
  giftCardPurchaseMsg: "Your reciepients will recieve an SMS shortly.",
  returnToGiftCards: "Return to Gift Cards",
  tipExceedsSubtotal: 'Le pourboire dépasse le sous-total',
  noResults: "N'A RETOURNÉ AUCUN RÉSULTAT",
  serves: "Sert",
  myFavouritelabel: "MES BOUTIQUES FAVORIS",
  myDeliveryAddresses: "MES ADRESSES DE LIVRAISON",
  kfcStore: "magasin KFC",
  yourorders: "VOS COMMANDES",
  quoteOrderNumber: 'CITATION VOTRE NUMÉRO DE COMMANDE #',
  cardValidatingTitle: 'VALIDATION',
  newCardText: 'NOUVELLE CARTE',
  cardValidationDesc: "Nous validons votre carte avec le fournisseur de paiement",
  removeGiftCard: "RETIRER LA CARTE CADEAU",
  giftCardContent: 'Voulez-vous vraiment supprimer cette carte-cadeau?',
  removeVoucher: 'RETIRER LE BON',
  voucherContent: 'Êtes-vous sûr de vouloir supprimer ce bon?',
  giftCardMealFullyCovered: "Woohoo! Votre carte-cadeau a couvert votre repas.",
  voucherMealFullyCovered: 'Woohoo! Votre bon a couvert votre repas.',
  voucherAboveSubtotal: 'Les bons sont à usage unique. Le solde au-dessus du sous-total du repas ne peut plus être utilisé.',
  giftCardAboveSubtotal: 'Woohoo! Votre carte-cadeau a couvert le repas. Utilisez votre solde restant une autre fois.',
  maxSubTotalValueCovered: 'La limite maximale du sous-total de la commande a été atteinte.',
  maxVoucherLimitExceeded: 'Le nombre maximum de chèques cadeaux a été appliqué.',
  giftCardToast: "Carte-cadeau supprimée",
  voucherToast: "Coupon supprimé",
  giftCardVoucherContent: "Les bons/cartes-cadeaux ajoutés seront effacés si vous mettez à jour le panier. Voulez-vous continuer?",
  removeGiftCardVoucher: "BON CLAIR/CARTE CADEAU",
  postOrderCouponFailure: "Votre temps pour échanger une carte-cadeau ou un bon a expiré. Veuillez réappliquer au panier et passer à la caisse.",
  reApplyGiftCardOrVoucher: 'Veuillez réappliquer une carte-cadeau valide ou un code de bon d`achat à votre commande.',
  savedCardPaymentTitle: "Cartes enregistrées",
  otherPaymentTitle: "Utiliser un autre mode de paiement",
  optionCurrentlyAvailable: "Option actuellement indisponible,",
  allowAllCookiesLink: "veuillez autoriser tous les cookies",
  enableText: "ici pour activer",
  ordertaxpst: 'Taxe de commande PST',
  deliverytaxhst: 'Taxe de livraison TVH',
  hst: 'TVH',
  gst: 'GST',
  pst: 'PST',
  mealFullyCoveredDeliveryFeeRemaining: "Almost there! Just the Additional Charges remaining to Place Order.",
  deliveryOptionsToolTip: "Veuillez sélectionner un élément dans la liste.",
  creditCardDetails: "CREDIT CARD DETAILS",
  selectPaymentMethod: "Select Payment Method",
  notNow: "Pas maintenant",
  other: "Autre"
};
exports.translation = translation;